<template>
  <v-card
    elevation="10"
    data-v-step="26"
    :min-height="!isMobile ? 740 : undefined"
    class="position-relative"
  >
    <!-- Overlay solo si la pregunta es obligatoria -->
    <div
      v-if="isQuestionPersistent && showResponsibilityQuestion"
      class="absolute-overlay"
    ></div>

    <AppSkeleton :condition="loadingNotification" type="notificationProperties">
      <template v-slot:skeleton-content>
        <div
          v-if="!isMobile"
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            min-height: 740px;
          "
        >
          <div>
            <!-- Botones de navegacion -->
            <v-row
              v-if="!isSharedAccess && hasNavigation"
              class="mt-0 pt-0"
              align="center"
            >
              <v-col cols="3">
                <div class="ml-2 d-flex justify-space-between align-center">
                  <!-- Anterior ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-inline-flex">
                        <v-btn
                          elevation="1"
                          fab
                          small
                          class="secondary--text ma-1"
                          id="go-to-previous-notification"
                          :disabled="!hasPrevious"
                          color="primary"
                          @click.stop="goToPrevious"
                        >
                          <v-icon> mdi-chevron-left </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <p v-html="tooltipPreviousText" class="tooltip-text"></p>
                  </v-tooltip>

                  <!-- Siguiente ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-inline-flex">
                        <v-btn
                          elevation="1"
                          fab
                          small
                          class="secondary--text ma-1"
                          id="go-to-next-notification"
                          :disabled="!hasNext"
                          color="primary"
                          @click.stop="goToNext"
                        >
                          <v-icon> mdi-chevron-right </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <p v-html="tooltipNextText" class="tooltip-text"></p>
                  </v-tooltip>

                  <!-- Volver ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="1"
                        fab
                        small
                        class="secondary--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        id="go-back-to-list"
                        color="primary"
                        @click.stop="goBackToList"
                      >
                        <v-icon> mdi-chevron-up </v-icon>
                      </v-btn>
                    </template>
                    <div>
                      {{ $t('goBackToList') }}
                    </div>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>

            <v-card-title>
              <v-row align="center">
                <h3 class="primary--text">
                  <v-icon x-large class="primary--text">
                    mdi-identifier
                  </v-icon>
                  {{ notification.id }}
                </h3>
                <v-spacer />
                <AlertDialog
                  data-v-step="23"
                  v-if="!isSharedAccess"
                  :asset="notification"
                  objectType="notifications"
                  :isDisabled="
                    isOperatorUser && !$store.state.user?.processNotification
                  "
                />
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="isAdminUser && !isColectivoUser"
                      elevation="1"
                      fab
                      small
                      class="secondary--text ma-1"
                      v-bind="attrs"
                      v-on="on"
                      id="list-operators"
                      :disabled="loadingData"
                      :color="operatorsListFlag ? 'warning' : 'primary'"
                      @click.stop="switchOperatorsListFlag()"
                    >
                      <v-icon> mdi-account-group </v-icon>
                    </v-btn>
                  </template>
                  <div>
                    {{ $t('notificationProperties.showOperators') }}
                  </div>
                </v-tooltip>

                <NotificationMetadata
                  v-if="
                    (notification.metadatas ||
                      (notification.conceptoMetadatos &&
                        notification.conceptoMetadatos.length > 0 &&
                        notification.conceptoMetadatos[0] &&
                        Object.keys(notification.conceptoMetadatos[0]).length >
                          0)) &&
                    !isColectivoUser
                  "
                  :notification="notification"
                />
              </v-row>
            </v-card-title>
            <v-list dense data-v-step="21">
              <v-list-item>
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.status') }}:
                </v-list-item-content>
                <v-chip
                  medium
                  class="white--text"
                  :color="getNotificationStatus(notification).color"
                >
                  <span class="headline">
                    {{ $t(getNotificationStatus(notification).status) }}
                  </span>
                </v-chip>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.concept') }}:
                </v-list-item-content>
                <!--v-list-item-content class="align-end headline"-->
                <v-list-item-content
                  class="align-end"
                  :class="[
                    notification.concepto?.length > 65
                      ? 'subtitle-1'
                      : 'headline',
                    'wrap-text',
                  ]"
                >
                  {{ notification.concepto }}
                </v-list-item-content>
              </v-list-item>

              <!-- Responsable (modo desktop , NO movil, no mobile) -->
              <v-list-item v-if="!isSharedAccess">
                <v-list-item-content data-v-step="24" class="title">
                  {{ $t('notificationProperties.manager') }}:
                </v-list-item-content>

                <v-list-item-content
                  v-if="!isSharedAccess"
                  class="headline d-flex flex-column align-start"
                >
                  <div class="d-flex flex-column align-end">
                    <template
                      v-if="
                        notification.managerAccepted === false &&
                        notification.manager
                      "
                    >
                      <v-col
                        v-if="notification.manager.id !== $store.state.user?.id"
                      >
                        <v-row>
                          <span class="body-1 text--secondary w-100">
                            <div v-if="isGroup(notification.managerRef)">
                              {{ $t('waitGroupManager') }}
                            </div>
                            <div v-else>
                              {{ $t('waitManager') }}
                            </div>
                          </span>
                          <span
                            v-if="notification.manager.disabled"
                            class="body-1 text--secondary"
                          >
                            {{ $t('userDisabled') }}
                          </span>
                          <span
                            v-if="notification.canBeManager === false"
                            class="body-1 text--secondary"
                          >
                            {{ $t('operatorWithoutAccess') }}
                          </span>
                        </v-row>

                        <!-- Avatar + nombre en una linea, ancho completo -->
                        <v-row class="d-flex align-center w-100">
                          <!-- El tooltip de un Grupo se muestra sin transparencia -->
                          <v-tooltip
                            top
                            :content-class="
                              isGroup(notification.managerRef)
                                ? 'tooltip-no-transparency'
                                : ''
                            "
                            :z-index="
                              isGroup(notification.managerRef) ? 20 : 10
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="{
                                  ...on,
                                  mouseenter: (e) =>
                                    onActivatorMouseEnter(e, notification, on),
                                }"
                              >
                                <AppAvatar
                                  v-if="notification.manager"
                                  class="ml-0"
                                  :userName="fullName(notification.manager)"
                                  :userAvatar="notification.manager?.avatarURL"
                                  :isGroup="isGroup(notification.managerRef)"
                                  :isDisabledOrDeleted="
                                    isGroup(notification.managerRef)
                                      ? notification.manager?.disabled ||
                                        notification.manager?.deleted
                                      : false
                                  "
                                  :avatarSize="
                                    isGroup(notification.managerRef)
                                      ? '34'
                                      : '30'
                                  "
                                  :initialsSize="
                                    isGroup(notification.managerRef) ? 11 : 14
                                  "
                                  iconSize="24"
                                  avatarColor="primary"
                                  initialsColor="secondary"
                                  :showWarn="
                                    notification.manager.disabled ||
                                    !notification.managerAccepted ||
                                    notification.manager.deleted ||
                                    notification.overlapIconColor ===
                                      'warning' ||
                                    notification.overlapIconColor === 'error'
                                  "
                                  __TODO_eliminar_:overlapIconColor="
                                    calculateOverlapIconColor(notification)
                                  "
                                  :overlapIconColor="
                                    notification.overlapIconColor
                                  "
                                />
                              </span>
                            </template>

                            <!-- Contenido del tooltip -->
                            <div v-if="isGroup(notification.managerRef)">
                              <div>
                                {{ $t('group') }}:
                                {{ fullName(notification.manager) }}
                                <b
                                  v-show="notification.manager.deleted"
                                  class="group-deleted"
                                >
                                  {{ $t('groupDeleted') }}
                                </b>
                              </div>
                            </div>
                            <div v-else>
                              {{ fullName(notification.manager) }}
                            </div>

                            <div v-if="!notification.managerAccepted">
                              <div v-if="isGroup(notification.managerRef)">
                                {{ $t('waitGroupManager') }}
                              </div>
                              <div v-else>
                                {{ $t('waitManager') }}
                              </div>
                            </div>

                            <div v-if="notification.manager.disabled">
                              {{ $t('userDisabled') }}
                            </div>
                            <div v-if="notification.canBeManager === false">
                              {{ $t('operatorWithoutAccess') }}
                            </div>

                            <div
                              v-if="
                                notification.groupAccess?.summary
                                  ?.acceptedOperatorDeletedFromGroup
                              "
                              class="d-flex align-start"
                            >
                              <v-icon color="error" class="mr-2"
                                >mdi-alert
                              </v-icon>
                              <div>
                                <div>
                                  {{ $t('acceptedOperatorDeletedFromGroup') }}:
                                </div>
                                <div>
                                  {{
                                    notification.groupAccess?.summary
                                      ?.acceptedOperatorDeletedFromGroupFullname
                                  }}
                                </div>
                              </div>
                            </div>

                            <!--Mostrar lista de operadores del grupo responsable -->
                            <div v-if="isGroup(notification.managerRef)">
                              <div
                                style="
                                  display: block;
                                  margin-top: 8px;
                                  margin-bottom: 10px;
                                "
                              >
                                {{ $t('groupOperators') }}:
                              </div>

                              <!-- estado: cargando -->
                              <div
                                v-if="
                                  notification.groupAccess?.status !== 'ready'
                                "
                                class="tooltip-loading"
                              >
                                <v-progress-circular
                                  indeterminate
                                  size="20"
                                  width="2"
                                />
                              </div>

                              <!-- estado: cargado -->
                              <template v-else>
                                <!-- si hay operadores -->
                                <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                <ul
                                  v-if="getGroupOperators(notification).length"
                                >
                                  <li
                                    v-for="(
                                      operator, index
                                    ) in getGroupOperatorsPreview(notification)"
                                    :key="index"
                                  >
                                    <v-row align="center">
                                      <AppAvatar
                                        class="mr-2 mt-3 mb-3"
                                        :userName="operator.fullName"
                                        :userAvatar="operator.avatarURL"
                                        avatarSize="30"
                                        iconSize="24"
                                        avatarColor="primary"
                                        initialsColor="secondary"
                                        :showWarn="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                        "
                                        :overlapIconColor="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                            ? 'error'
                                            : undefined
                                        "
                                      />
                                      <span class="mr-2 mt-3 mb-3">
                                        {{ operator.fullName }} :
                                        {{
                                          operatorAccessText(
                                            operator,
                                            notification
                                          )
                                        }}
                                        <template
                                          v-if="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.response.responded
                                          "
                                        >
                                          <v-icon
                                            :color="
                                              notification.groupAccess.map[
                                                operator.id
                                              ].response.color
                                            "
                                            size="15"
                                            class="ml-1 mb-1"
                                          >
                                            mdi-circle
                                          </v-icon>
                                          {{
                                            notification.groupAccess.map[
                                              operator.id
                                            ].response.text
                                          }}
                                        </template>
                                      </span>
                                    </v-row>
                                  </li>
                                  <br />
                                </ul>
                                <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                <div
                                  v-if="
                                    getGroupOperators(notification).length >
                                    maxOperatorsPreview
                                  "
                                  class="group-operators-info"
                                >
                                  <v-chip
                                    small
                                    _color="grey lighten-4"
                                    _text-color="grey darken-3"
                                    color="primary"
                                    text-color="seconday"
                                    class="operator-count-chip"
                                  >
                                    +{{
                                      getGroupOperators(notification).length -
                                      maxOperatorsPreview
                                    }}
                                  </v-chip>
                                  <span class="operator-count-text">{{
                                    $t('groupOperators')
                                  }}</span>
                                </div>

                                <!-- estado: cargado pero grupo vacio -->
                                <div
                                  v-if="!getGroupOperators(notification).length"
                                >
                                  <ul>
                                    <li>{{ $t('withoutOperators') }}</li>
                                  </ul>
                                </div>
                              </template>
                            </div>
                          </v-tooltip>

                          <span class="ml-1 body-1 text--secondary">
                            {{ fullName(notification.manager) }}
                          </span>

                          <v-btn
                            v-if="
                              !isOperatorUser ||
                              $store.state.user?.processNotification
                            "
                            small
                            icon
                            color="error"
                            @click="questionRemoveManager()"
                            id="remove-manager"
                          >
                            <v-icon> mdi-window-close </v-icon>
                          </v-btn>

                          <!-- nuevo boton por si se 'arrepiente' de haber rechazado -->
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-show="canAskAgain"
                                elevation="1"
                                fab
                                small
                                class="secondary--text ma-1"
                                v-bind="attrs"
                                v-on="on"
                                id="ask-again"
                                color="primary"
                                @click="askAgainFlag = true"
                              >
                                <v-icon> mdi-account-hard-hat-outline </v-icon>
                              </v-btn>
                            </template>
                            <div>
                              {{ $t('askResponsability.title') }}
                            </div>
                          </v-tooltip>
                        </v-row>
                      </v-col>

                      <v-row v-else>
                        <v-col cols="8">
                          <span class="body-1">
                            {{ $t('acceptResponsibility') }}
                          </span>
                        </v-col>
                        <v-col cols="4" class="d-flex justify-end">
                          <v-btn
                            class="mx-3"
                            color="primary"
                            icon
                            plain
                            @click="() => acceptNotification(notification)"
                          >
                            <v-icon>mdi-check</v-icon>
                          </v-btn>
                          <v-btn
                            class="mx-3"
                            color="error"
                            icon
                            plain
                            @click="() => declineNotification(notification)"
                          >
                            <v-icon>mdi-window-close</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>

                    <AppSkeleton
                      v-else-if="
                        !isOperatorUser ||
                        $store.state.user?.processNotification
                      "
                      :condition="loadingOperators"
                      type="assignManager"
                    >
                      <template v-slot:skeleton-content>
                        <div>
                          <!-- nuevo, al haber quitado el select y sustituirlo por un menu: -->
                          <!-- mostrar manager actual cuando está aceptado -->
                          <v-menu
                            v-model="menu"
                            offset-y
                            left
                            :close-on-content-click="false"
                            content-class="responsible-menu"
                            :nudge-bottom="4"
                            :max-height="370"
                            :min-width="500"
                          >
                            <!-- Activator = antiguo v-select -->
                            <template v-slot:activator="{ on, attrs }">
                              <v-row
                                v-bind="attrs"
                                v-on="on"
                                align="center"
                                no-gutters
                                class="pa-2 pl-0"
                                style="cursor: pointer"
                              >
                                <!-- mostrar icono usuario solo si no esta aceptada la responsabilidad -->
                                <v-icon
                                  v-if="!notification.managerAccepted"
                                  class="mr-2"
                                  >mdi-account</v-icon
                                >

                                <!-- contenedor unico tipo select -->
                                <v-sheet
                                  v-bind="attrs"
                                  v-on="on"
                                  outlined
                                  rounded
                                  class="pa-2 d-flex align-center"
                                  style="cursor: pointer"
                                >
                                  <!-- manager aceptado -->
                                  <template
                                    v-if="
                                      notification.manager &&
                                      notification.managerAccepted === true
                                    "
                                  >
                                    <!-- manager aceptado + mostrar tooltip -->
                                    <!-- El tooltip de un Grupo se muestra sin transparencia -->
                                    <v-tooltip
                                      top
                                      :content-class="
                                        isGroup(notification.managerRef)
                                          ? 'tooltip-no-transparency'
                                          : ''
                                      "
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <span
                                          v-bind="attrs"
                                          v-on="{
                                            ...on,
                                            mouseenter: (e) =>
                                              onActivatorMouseEnter(
                                                e,
                                                notification,
                                                on
                                              ),
                                          }"
                                        >
                                          <AppAvatar
                                            v-if="notification.manager"
                                            class="ml-0"
                                            :userName="
                                              fullName(notification.manager)
                                            "
                                            :userAvatar="
                                              notification.manager?.avatarURL
                                            "
                                            :isGroup="
                                              isGroup(notification.managerRef)
                                            "
                                            :isDisabledOrDeleted="
                                              isGroup(notification.managerRef)
                                                ? notification.manager
                                                    ?.disabled ||
                                                  notification.manager?.deleted
                                                : false
                                            "
                                            :avatarSize="
                                              isGroup(notification.managerRef)
                                                ? '34'
                                                : '30'
                                            "
                                            :initialsSize="
                                              isGroup(notification.managerRef)
                                                ? 11
                                                : 14
                                            "
                                            iconSize="24"
                                            avatarColor="primary"
                                            initialsColor="secondary"
                                            :showWarn="
                                              notification.manager.disabled ||
                                              !notification.managerAccepted ||
                                              notification.manager.deleted ||
                                              notification.overlapIconColor ===
                                                'warning' ||
                                              notification.overlapIconColor ===
                                                'error'
                                            "
                                            :overlapIconColor="
                                              notification.overlapIconColor
                                            "
                                          />
                                        </span>
                                      </template>

                                      <!-- Contenido del tooltip -->
                                      <div
                                        v-if="isGroup(notification.managerRef)"
                                      >
                                        <div>
                                          {{ $t('group') }}:
                                          {{ fullName(notification.manager) }}
                                          <b
                                            v-show="
                                              notification.manager.deleted
                                            "
                                            class="group-deleted"
                                          >
                                            {{ $t('groupDeleted') }}
                                          </b>
                                        </div>
                                      </div>
                                      <div v-else>
                                        {{ fullName(notification.manager) }}
                                      </div>

                                      <div v-if="!notification.managerAccepted">
                                        <div
                                          v-if="
                                            isGroup(notification.managerRef)
                                          "
                                        >
                                          {{ $t('waitGroupManager') }}
                                        </div>
                                        <div v-else>
                                          {{ $t('waitManager') }}
                                        </div>
                                      </div>

                                      <div v-if="notification.manager.disabled">
                                        {{ $t('userDisabled') }}
                                      </div>
                                      <div
                                        v-if="
                                          notification.canBeManager === false
                                        "
                                      >
                                        {{ $t('operatorWithoutAccess') }}
                                      </div>

                                      <div
                                        v-if="
                                          notification.groupAccess?.summary
                                            ?.acceptedOperatorDeletedFromGroup
                                        "
                                        class="d-flex align-start"
                                      >
                                        <v-icon color="error" class="mr-2"
                                          >mdi-alert
                                        </v-icon>
                                        <div>
                                          <div>
                                            {{
                                              $t(
                                                'acceptedOperatorDeletedFromGroup'
                                              )
                                            }}:
                                          </div>
                                          <div>
                                            {{
                                              notification.groupAccess?.summary
                                                ?.acceptedOperatorDeletedFromGroupFullname
                                            }}
                                          </div>
                                        </div>
                                      </div>

                                      <!--Mostrar lista de operadores del grupo responsable -->
                                      <div
                                        v-if="isGroup(notification.managerRef)"
                                      >
                                        <div
                                          style="
                                            display: block;
                                            margin-top: 8px;
                                            margin-bottom: 10px;
                                          "
                                        >
                                          {{ $t('groupOperators') }}:
                                        </div>

                                        <!-- estado: cargando -->
                                        <div
                                          v-if="
                                            notification.groupAccess?.status !==
                                            'ready'
                                          "
                                          class="tooltip-loading"
                                        >
                                          <v-progress-circular
                                            indeterminate
                                            size="20"
                                            width="2"
                                          />
                                        </div>

                                        <!-- estado: cargado -->
                                        <template v-else>
                                          <!-- si hay operadores -->
                                          <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                          <ul
                                            v-if="
                                              getGroupOperators(notification)
                                                .length
                                            "
                                          >
                                            <li
                                              v-for="(
                                                operator, index
                                              ) in getGroupOperatorsPreview(
                                                notification
                                              )"
                                              :key="index"
                                            >
                                              <v-row align="center">
                                                <AppAvatar
                                                  class="mr-2 mt-3 mb-3"
                                                  :userName="operator.fullName"
                                                  :userAvatar="
                                                    operator.avatarURL
                                                  "
                                                  avatarSize="30"
                                                  iconSize="24"
                                                  avatarColor="primary"
                                                  initialsColor="secondary"
                                                  :showWarn="
                                                    notification.groupAccess
                                                      ?.map[operator.id]
                                                      ?.hasError
                                                  "
                                                  :overlapIconColor="
                                                    notification.groupAccess
                                                      ?.map[operator.id]
                                                      ?.hasError
                                                      ? 'error'
                                                      : undefined
                                                  "
                                                />
                                                <span class="mr-2 mt-3 mb-3">
                                                  {{ operator.fullName }} :
                                                  {{
                                                    operatorAccessText(
                                                      operator,
                                                      notification
                                                    )
                                                  }}
                                                  <template
                                                    v-if="
                                                      notification.groupAccess
                                                        ?.map[operator.id]
                                                        ?.response.responded
                                                    "
                                                  >
                                                    <v-icon
                                                      :color="
                                                        notification.groupAccess
                                                          .map[operator.id]
                                                          .response.color
                                                      "
                                                      size="15"
                                                      class="ml-1 mb-1"
                                                    >
                                                      mdi-circle
                                                    </v-icon>
                                                    {{
                                                      notification.groupAccess
                                                        .map[operator.id]
                                                        .response.text
                                                    }}
                                                  </template>
                                                </span>
                                              </v-row>
                                            </li>
                                            <br />
                                          </ul>
                                          <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                          <div
                                            v-if="
                                              getGroupOperators(notification)
                                                .length > maxOperatorsPreview
                                            "
                                            class="group-operators-info"
                                          >
                                            <v-chip
                                              small
                                              _color="grey lighten-4"
                                              _text-color="grey darken-3"
                                              color="primary"
                                              text-color="seconday"
                                              class="operator-count-chip"
                                            >
                                              +{{
                                                getGroupOperators(notification)
                                                  .length - maxOperatorsPreview
                                              }}
                                            </v-chip>
                                            <span class="operator-count-text">{{
                                              $t('groupOperators')
                                            }}</span>
                                          </div>
                                          <!-- estado: cargado pero grupo vacio -->
                                          <div
                                            v-if="
                                              !getGroupOperators(notification)
                                                .length
                                            "
                                          >
                                            <ul>
                                              <li>
                                                {{ $t('withoutOperators') }}
                                              </li>
                                            </ul>
                                          </div>
                                        </template>
                                      </div>
                                    </v-tooltip>

                                    <span class="body-1 text--secondary ml-2">
                                      {{ fullName(notification.manager) }}
                                    </span>

                                    <v-btn
                                      v-if="
                                        !isOperatorUser ||
                                        $store.state.user?.processNotification
                                      "
                                      color="error"
                                      icon
                                      small
                                      @click.stop="questionRemoveManager()"
                                    >
                                      <v-icon small>mdi-window-close</v-icon>
                                    </v-btn>
                                  </template>

                                  <!-- sin manager -->
                                  <span v-else class="body-1 text--secondary">
                                    {{ $t('assignManager') }}
                                  </span>

                                  <!-- spacer -->
                                  <v-spacer />

                                  <!-- flecha (para simular el append-icon del v-select antiguo) -->
                                  <v-icon>mdi-menu-down</v-icon>
                                </v-sheet>
                              </v-row>
                            </template>

                            <!-- Menu de usuarios y grupos -->
                            <v-card>
                              <v-card-title>
                                {{ $t('assignManagerNotification') }}
                              </v-card-title>
                              <v-card-text>
                                <v-text-field
                                  v-model="managerSearch"
                                  clearable
                                  prepend-icon="mdi-magnify"
                                  :label="$t('searchField')"
                                  single-line
                                  hide-details
                                />
                                <v-divider class="mt-2 mb-2" />

                                <!--Mostrar lista de posibles operadores asignables como responsable -->
                                <v-row no-gutters>
                                  <v-col cols="6">
                                    <strong>{{ $t('operators') }}</strong>
                                    <!-- mostrar avatar y nombre de cada operador -->
                                    <v-list dense>
                                      <v-list-item
                                        v-for="manager in filteredPosibleManagers"
                                        :key="manager.id"
                                        @click="
                                          notification.managerRef
                                            ? setNewManager(
                                                manager.id,
                                                manager.fullName
                                              )
                                            : selectManager(manager.id)
                                        "
                                        :class="{
                                          'v-list-item--active primary--text v-list-item--highlighted':
                                            notification.managerRef?.id ===
                                            manager.id,
                                        }"
                                      >
                                        <AppAvatar
                                          class="mr-3"
                                          :userName="manager.fullName"
                                          :userAvatar="manager.avatarURL"
                                          avatarSize="30"
                                          iconSize="24"
                                          avatarColor="primary"
                                          initialsColor="secondary"
                                        />
                                        {{ manager.fullName }}
                                      </v-list-item>
                                    </v-list>
                                  </v-col>

                                  <!--Mostrar lista de posibles grupos asignables como responsable -->
                                  <v-col cols="6">
                                    <strong>{{ $t('tabTitle.groups') }}</strong>
                                    <v-list dense>
                                      <v-list-item
                                        v-for="group in filteredPosibleGroups"
                                        :key="group.id"
                                        @click="
                                          notification.managerRef
                                            ? setNewGroup(
                                                group.id,
                                                group.fullName
                                              )
                                            : selectGroup(group.id)
                                        "
                                        :class="{
                                          'v-list-item--active primary--text v-list-item--highlighted':
                                            notification.managerRef?.id ===
                                            group.id,
                                        }"
                                      >
                                        <AppAvatar
                                          class="mr-3"
                                          :userName="group.fullName"
                                          :isGroup="true"
                                          avatarSize="38"
                                          :initialsSize="
                                            isGroup(notification.managerRef)
                                              ? 11
                                              : 14
                                          "
                                          iconSize="24"
                                          avatarColor="secondary"
                                          initialsColor="primary"
                                        />
                                        {{ group.fullName }}
                                      </v-list-item>
                                    </v-list>
                                  </v-col>
                                </v-row>
                              </v-card-text>
                            </v-card>
                          </v-menu>
                        </div>
                      </template>
                    </AppSkeleton>

                    <template v-else>
                      <div
                        v-if="notification.manager"
                        class="d-flex align-center justify-end w-100"
                      >
                        <!-- Avatar + nombre en una linea, ancho completo -->
                        <v-row class="d-flex align-center w-100 no-gutters">
                          <!-- El tooltip de un Grupo se muestra sin transparencia -->
                          <v-tooltip
                            top
                            :content-class="
                              isGroup(notification.managerRef)
                                ? 'tooltip-no-transparency'
                                : ''
                            "
                            :z-index="
                              isGroup(notification.managerRef) ? 20 : 10
                            "
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <span
                                v-bind="attrs"
                                v-on="{
                                  ...on,
                                  mouseenter: (e) =>
                                    onActivatorMouseEnter(e, notification, on),
                                }"
                              >
                                <AppAvatar
                                  v-if="notification.manager"
                                  class="ml-0"
                                  :userName="fullName(notification.manager)"
                                  :userAvatar="notification.manager?.avatarURL"
                                  :isGroup="isGroup(notification.managerRef)"
                                  :avatarSize="
                                    isGroup(notification.managerRef)
                                      ? '34'
                                      : '30'
                                  "
                                  :initialsSize="
                                    isGroup(notification.managerRef) ? 11 : 14
                                  "
                                  iconSize="24"
                                  avatarColor="primary"
                                  initialsColor="secondary"
                                  :showWarn="
                                    notification.manager.disabled ||
                                    !notification.managerAccepted ||
                                    notification.manager.deleted ||
                                    notification.overlapIconColor ===
                                      'warning' ||
                                    notification.overlapIconColor === 'error'
                                  "
                                  :overlapIconColor="
                                    notification.overlapIconColor
                                  "
                                />
                              </span>
                            </template>

                            <!-- Contenido del tooltip -->
                            <div v-if="isGroup(notification.managerRef)">
                              <div>
                                {{ $t('group') }}:
                                {{ fullName(notification.manager) }}
                                <b
                                  v-show="notification.manager.deleted"
                                  class="group-deleted"
                                >
                                  {{ $t('groupDeleted') }}
                                </b>
                              </div>
                            </div>
                            <div v-else>
                              {{ fullName(notification.manager) }}
                            </div>

                            <div v-if="!notification.managerAccepted">
                              <div v-if="isGroup(notification.managerRef)">
                                {{ $t('waitGroupManager') }}
                              </div>
                              <div v-else>
                                {{ $t('waitManager') }}
                              </div>
                            </div>

                            <div v-if="notification.manager.disabled">
                              {{ $t('userDisabled') }}
                            </div>
                            <div v-if="notification.canBeManager === false">
                              {{ $t('operatorWithoutAccess') }}
                            </div>

                            <div
                              v-if="
                                notification.groupAccess?.summary
                                  ?.acceptedOperatorDeletedFromGroup
                              "
                              class="d-flex align-start"
                            >
                              <v-icon color="error" class="mr-2"
                                >mdi-alert
                              </v-icon>
                              <div>
                                <div>
                                  {{ $t('acceptedOperatorDeletedFromGroup') }}:
                                </div>
                                <div>
                                  {{
                                    notification.groupAccess?.summary
                                      ?.acceptedOperatorDeletedFromGroupFullname
                                  }}
                                </div>
                              </div>
                            </div>

                            <!--Mostrar lista de operadores del grupo responsable -->
                            <div v-if="isGroup(notification.managerRef)">
                              <div
                                style="
                                  display: block;
                                  margin-top: 8px;
                                  margin-bottom: 10px;
                                "
                              >
                                {{ $t('groupOperators') }}:
                              </div>

                              <!-- estado: cargando -->
                              <div
                                v-if="
                                  notification.groupAccess?.status !== 'ready'
                                "
                                class="tooltip-loading"
                              >
                                <v-progress-circular
                                  indeterminate
                                  size="20"
                                  width="2"
                                />
                              </div>

                              <!-- estado: cargado -->
                              <template v-else>
                                <!-- si hay operadores -->
                                <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                <ul
                                  v-if="getGroupOperators(notification).length"
                                >
                                  <li
                                    v-for="(
                                      operator, index
                                    ) in getGroupOperatorsPreview(notification)"
                                    :key="index"
                                  >
                                    <v-row align="center">
                                      <AppAvatar
                                        class="mr-2 mt-3 mb-3"
                                        :userName="operator.fullName"
                                        :userAvatar="operator.avatarURL"
                                        avatarSize="30"
                                        iconSize="24"
                                        avatarColor="primary"
                                        initialsColor="secondary"
                                        :showWarn="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                        "
                                        :overlapIconColor="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                            ? 'error'
                                            : undefined
                                        "
                                      />
                                      <span class="mr-2 mt-3 mb-3">
                                        {{ operator.fullName }} :
                                        {{
                                          operatorAccessText(
                                            operator,
                                            notification
                                          )
                                        }}
                                        <template
                                          v-if="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.response.responded
                                          "
                                        >
                                          <v-icon
                                            :color="
                                              notification.groupAccess.map[
                                                operator.id
                                              ].response.color
                                            "
                                            size="15"
                                            class="ml-1 mb-1"
                                          >
                                            mdi-circle
                                          </v-icon>
                                          {{
                                            notification.groupAccess.map[
                                              operator.id
                                            ].response.text
                                          }}
                                        </template>
                                      </span>
                                    </v-row>
                                  </li>
                                  <br />
                                </ul>
                                <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                <div
                                  v-if="
                                    getGroupOperators(notification).length >
                                    maxOperatorsPreview
                                  "
                                  class="group-operators-info"
                                >
                                  <v-chip
                                    small
                                    _color="grey lighten-4"
                                    _text-color="grey darken-3"
                                    color="primary"
                                    text-color="seconday"
                                    class="operator-count-chip"
                                  >
                                    +{{
                                      getGroupOperators(notification).length -
                                      maxOperatorsPreview
                                    }}
                                  </v-chip>
                                  <span class="operator-count-text">{{
                                    $t('groupOperators')
                                  }}</span>
                                </div>

                                <!-- estado: cargado pero grupo vacio -->
                                <div
                                  v-if="!getGroupOperators(notification).length"
                                >
                                  <ul>
                                    <li>{{ $t('withoutOperators') }}</li>
                                  </ul>
                                </div>
                              </template>
                            </div>
                          </v-tooltip>

                          <span class="body-1 text--secondary ml-2">
                            {{ fullName(notification.manager) }}
                          </span>
                        </v-row>
                      </div>

                      <v-list-item-content class="align-end subtitle-1" v-else>
                        <span class="font-weight-black">
                          {{ $t('noManagerAssigned') }}
                        </span>
                      </v-list-item-content>
                    </template>
                  </div>

                  <!-- preguntar a un operador del grupo asignado si acepta o no la responsabilidad -->
                  <v-expand-transition>
                    <v-card
                      v-show="shouldShowResponsibilityCard"
                      class="mt-3 align-self-stretch responsibility-card"
                      :class="{ 'is-persistent': isQuestionPersistent }"
                      outlined
                    >
                      <v-card-title class="subtitle-1">
                        {{ $t('askResponsability.title') }}
                      </v-card-title>

                      <v-card-text class="body-2">
                        {{ $t('askResponsability.message') }}
                      </v-card-text>

                      <v-divider />

                      <v-card-actions class="justify-center">
                        <v-btn
                          color="primary"
                          text
                          @click="acceptResponsibilityQuestion"
                        >
                          {{ $t('askResponsability.accept') }}
                        </v-btn>

                        <v-btn
                          :disabled="askAgainFlag"
                          color="error"
                          text
                          @click="rejectResponsibilityQuestion"
                        >
                          {{ $t('askResponsability.reject') }}
                        </v-btn>

                        <v-btn
                          v-if="showAskLaterButton || askAgainFlag"
                          text
                          @click="askLaterResponsibilityQuestion"
                        >
                          {{ $t('askResponsability.askLater') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expand-transition>

                  <template>
                    <!-- Nuevo boton que indica que hay en total N operadores, cuando no caben todos en el tooltip -->
                    <!-- Nuevo menu para mostrar todos los operadores de un grupo, cuando no caben todos en el tooltip -->
                    <!-- contenedor de la fila del botón, reservamos espacio fijo para evitar saltos, -->
                    <!-- y usamos v-show para mostrar o no -->
                    <div class="group-operators-btn-wrapper">
                      <v-menu
                        v-model="menuAllGroupOperators"
                        offset-y
                        left
                        :close-on-content-click="false"
                        content-class="responsible-menu"
                        :nudge-bottom="4"
                        :max-height="350"
                        :min-width="500"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            v-bind="attrs"
                            v-on="on"
                            text
                            small
                            class="ml-0 px-0"
                            color="primary"
                            v-show="showAllOperatorsButton"
                          >
                            {{
                              $t('seeThe') +
                              getGroupOperators(notification).length
                            }}
                            {{ $t('groupOperators') }}
                          </v-btn>
                        </template>

                        <v-card>
                          <v-card-text class="pa-2">
                            <v-text-field
                              v-model="operatorsSearch"
                              clearable
                              prepend-icon="mdi-magnify"
                              :label="$t('searchField')"
                              single-line
                              hide-details
                            />
                            <v-divider class="mt-2 mb-2" />

                            <!--Mostrar lista de todos los operadores del grupo -->
                            <v-row no-gutters>
                              <v-col>
                                <strong>{{ $t('groupOperators') }}:</strong>
                                <!-- mostrar avatar y nombre de cada operador -->
                                <v-list dense>
                                  <v-list-item
                                    v-for="operator in filteredGroupOperators"
                                    :key="operator.id"
                                  >
                                    <AppAvatar
                                      class="mr-3"
                                      :userName="operator.fullName"
                                      :userAvatar="operator.avatarURL"
                                      avatarSize="30"
                                      iconSize="24"
                                      avatarColor="primary"
                                      initialsColor="secondary"
                                      :showWarn="
                                        notification.groupAccess?.map[
                                          operator.id
                                        ]?.hasError
                                      "
                                      :overlapIconColor="
                                        notification.groupAccess?.map[
                                          operator.id
                                        ]?.hasError
                                          ? 'error'
                                          : undefined
                                      "
                                    />
                                    <span class="mr-2 mt-3 mb-3">
                                      {{ operator.fullName }} :
                                      {{
                                        operatorAccessText(
                                          operator,
                                          notification
                                        )
                                      }}
                                      <template
                                        v-if="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.response.responded
                                        "
                                      >
                                        <v-icon
                                          :color="
                                            notification.groupAccess.map[
                                              operator.id
                                            ].response.color
                                          "
                                          size="15"
                                          class="ml-1 mb-1"
                                        >
                                          mdi-circle
                                        </v-icon>
                                        {{
                                          notification.groupAccess.map[
                                            operator.id
                                          ].response.text
                                        }}
                                      </template>
                                    </span>
                                  </v-list-item>
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </div>
                  </template>
                </v-list-item-content>
              </v-list-item>
              <!-- hasta aqui el Responsable ---->

              <v-list-item>
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.receiver') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <span>{{ notification.nombre_titular }} </span>
                  <span
                    class="font-weight-black"
                    v-if="
                      !isEmptyNifTitular(notification) &&
                      !isIgnoredNifTitular(notification)
                    "
                  >
                    {{ notification.nif_titular }}
                  </span>

                  <!-- Notificacion sin NIF Titular o marcado como IGNORAR-->
                  <v-flex
                    v-else-if="
                      isEmptyNifTitular(notification) ||
                      isIgnoredNifTitular(notification)
                    "
                    class="d-flex align-center mt-n2"
                  >
                    <span class="without-nif">
                      {{
                        isEmptyNifTitular(notification)
                          ? $t('notificationWithoutNifTitular')
                          : notification.nif_titular
                      }}
                    </span>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-if="isSuperAdminUser || isSuperOperatorUser"
                          @click="showEditNifDialog()"
                          color="primary"
                          class="secondary--text ma-2"
                          v-bind="attrs"
                          v-on="on"
                          id="edit-nif"
                          :disabled="loadingData"
                        >
                          <v-icon class="mr-2" dark> mdi-pencil </v-icon>
                          {{ $t('editNifButtonText') }}
                        </v-btn>
                      </template>
                      <span>
                        {{ $t('editNifButtonTooltip') }}
                      </span>
                    </v-tooltip>
                  </v-flex>
                </v-list-item-content>
              </v-list-item>

              <!-- Nif titular original -->
              <v-list-item v-if="isTitularOriginalModificado(notification)">
                <v-list-item-content class="title">
                  <span class="nif-wrapper">
                    {{ $t('notificationProperties.originalReceiver') }}:
                    <v-icon color="warning" size="25" class="ml-1">
                      mdi-information
                    </v-icon>
                  </span>
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <span
                    >{{ notification?.titular_original_nombre ?? '' }}
                  </span>
                  <span class="font-weight-black">
                    {{ notification?.titular_original_nif ?? '' }}
                  </span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="notification.origen !== 'MANUAL'">
                <v-list-item-content class="title">
                  {{
                    notification.origen === 'SEGSOCIAL'
                      ? $t('notificationProperties.idSegSocial')
                      : $t('notificationProperties.idDehu')
                  }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <span>{{ notification.identificador }} </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.notificationType') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end headline">
                  <span>
                    <v-icon medium color="primary">
                      {{ getNotificationType(notification).icon }}
                    </v-icon>
                    {{ $t(getNotificationType(notification).name) }}
                  </span>
                </v-list-item-content>
              </v-list-item>

              <v-list-item v-if="docLink !== ''">
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.notificationDocLink') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end headline">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on">
                        <a :href="docLink" target="_blank">{{
                          $t('notificationProperties.notificationDocLinkBtn')
                        }}</a>
                      </span>
                    </template>
                    <div>{{ docLink }}</div>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>

              <v-list-item>
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.orgSender') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <span class="font-weight-black">{{
                    notification.codigo_organismo_emisor
                  }}</span>
                  {{ notification.nombre_organismo_emisor }}
                </v-list-item-content>
              </v-list-item>

              <v-list-item data-v-step="22">
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.orgSenderSource') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <span class="font-weight-black">
                    {{ notification.codigo_organismo_emisor_raiz }}
                  </span>
                  <span> {{ notification.nombre_organismo_emisor_raiz }} </span>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="notification.fecha_puesta_disposicion">
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.acceptSent') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  {{
                    $d(
                      new Date(notification.fecha_puesta_disposicion),
                      'i18nDateAndHourSeconds'
                    )
                  }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-if="notification.fecha_aceptacion">
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.acceptDate') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  {{
                    $d(
                      new Date(notification.fecha_aceptacion),
                      'i18nDateAndHourSeconds'
                    )
                  }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="
                  notification.fecha_expiracion &&
                  notification.fecha_expiracion < new Date()
                "
              >
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.expirationDate') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  {{
                    $d(
                      new Date(notification.fecha_expiracion),
                      'i18nDateAndHourSeconds'
                    )
                  }}
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-else-if="
                  notification.fecha_expiracion &&
                  notification.fecha_expiracion >= new Date()
                "
              >
                <v-list-item-content class="title">
                  {{ $t('notificationProperties.remaining') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <TimerCountdown
                    v-if="notification.fecha_puesta_disposicion"
                    :starttime="notification.fecha_puesta_disposicion"
                    :endtime="notification.fecha_expiracion"
                    hideMessage="true"
                    from="NotificationPropertiesCard"
                  >
                  </TimerCountdown>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-if="
                  !isSharedAccess &&
                  (!isOperatorUser || $store.state.user?.processNotification)
                "
              >
                <v-list-item-content class="title">
                  {{ $t('observation') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  <v-row no-gutters align="center">
                    <v-col cols="12">
                      <v-textarea
                        outlined
                        v-model="observation"
                        :rows="observation.length < 80 ? 2 : 6"
                        :class="[
                          'mb-0',
                          observation.length < 80 ? 'auto-grow' : '',
                        ]"
                        :value="notification.observation"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      v-if="
                        (notification.observation &&
                          observation !== notification.observation) ||
                        (!notification.observation && observation)
                      "
                    >
                      <v-btn
                        block
                        class="mt-n7"
                        color="primary"
                        @click.stop="confirmObservation()"
                      >
                        {{ $t('saveObservation') }}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
              <v-list-item v-else>
                <v-list-item-content class="title">
                  {{ $t('observation') }}:
                </v-list-item-content>
                <v-list-item-content class="align-end subtitle-1">
                  {{ notification.observation }}
                </v-list-item-content>
              </v-list-item>

              <v-progress-linear
                v-if="loadingData"
                indeterminate
                color="primary"
              >
              </v-progress-linear>
            </v-list>
          </div>
          <v-card-actions v-if="notification && !isSharedAccess">
            <v-dialog
              v-if="!notification.document && !notification.isComparecida"
              v-model="dialog"
              width="500"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="ma-2 secondary--text"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loadingData"
                  id="open-notif"
                >
                  {{ $t('openNotification') }}
                  <v-icon right dark> mdi-lock-open-variant-outline </v-icon>
                </v-btn>
              </template>

              <v-card
                v-if="
                  !isOperatorUser || $store.state.user?.downloadNotification
                "
              >
                <v-card-title class="text-h5 grey lighten-2">
                  <v-container>
                    <v-row justify="space-between" align="center">
                      <span>
                        {{ $t('confirmAcceptanceTitle') }}
                      </span>
                      <v-btn fab @click="dialog = false" small plain>
                        <v-icon> mdi-close </v-icon>
                      </v-btn>
                    </v-row>
                  </v-container>
                </v-card-title>
                <v-card-text class="pt-4">
                  {{ $t('confirmAcceptanceText') }}
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="confirmAcceptNotification()"
                    color="primary"
                    text
                    id="confirm-open-notif"
                  >
                    {{ $t('confirmAcceptance') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="text-h5 grey lighten-2">
                  {{ $t('noDownloadPermissionTitle') }}
                </v-card-title>
                <v-card-text>
                  {{ $t('noDownloadPermissionText') }}
                </v-card-text>
                <v-divider></v-divider>
              </v-card>
            </v-dialog>
            <v-btn
              v-if="
                !notification.document &&
                notification.isComparecida &&
                userCanAttach
              "
              @click="addDocsDialog = true"
              color="primary"
              class="ma-2 secondary--text"
              id="attach-files"
            >
              <v-icon class="mr-2" dark>
                mdi-file-document-plus-outline
              </v-icon>
              {{ $t('attachFiles') }}
            </v-btn>
            <v-btn
              v-if="userCanChangeStatus"
              @click="changeStatusDialog = true"
              color="primary"
              class="ma-2 secondary--text"
              id="change-status"
            >
              <v-icon class="mr-2" dark> mdi-swap-horizontal </v-icon>
              {{ $t('changeStatus') }}
            </v-btn>

            <v-dialog v-model="shareDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  data-v-step="25"
                  color="primary"
                  class="ma-2 secondary--text"
                  v-bind="attrs"
                  v-on="on"
                  :disabled="loadingData"
                  id="share-notif-button"
                >
                  <v-icon right dark> mdi-share </v-icon>
                  {{ $t('notificationProperties.share') }}
                </v-btn>
              </template>

              <v-card
                v-if="!isOperatorUser || $store.state.user?.processNotification"
              >
                <v-card-title class="text-h5 grey lighten-2">
                  {{ $t('confirmShareTitle') }}
                </v-card-title>
                <v-tabs v-model="tab" fixed-tabs>
                  <v-tab id="share-via-link-tab">{{
                    $t('shareViaLink')
                  }}</v-tab>
                  <v-tab id="share-via-email-tab">{{
                    $t('shareViaEmail')
                  }}</v-tab>
                </v-tabs>
                <v-form
                  ref="shareForm"
                  v-model="validShareForm"
                  lazy-validation
                  v-if="tab === 0"
                >
                  <v-container>
                    <v-card-text>
                      {{ $t('confirmShareTextLink') }}
                    </v-card-text>
                    <v-text-field
                      v-model="shareIdentifier"
                      :counter="100"
                      :label="$t('shareIdentifier')"
                      required
                      :rules="shareIdentifierRules"
                      id="share-identifier"
                    ></v-text-field>
                  </v-container>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="shareNotification('link')"
                      :disabled="loadingData"
                      color="primary"
                      text
                      id="confirm-share-link-notif"
                    >
                      {{ $t('confirmShareAndCopy') }}
                      <v-icon class="ml-1" small> mdi-content-copy </v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-form>
                <v-form
                  ref="shareForm"
                  v-model="validShareForm"
                  lazy-validation
                  v-if="tab === 1"
                >
                  <v-container>
                    <v-card-text class="mb-0 pb-0">
                      {{ $t('confirmShareText') }}
                    </v-card-text>
                    <v-row class="mt-0 pt-0">
                      <v-col align="right" class="mt-0 pt-0">
                        <v-btn
                          @click="getCompanyEmail()"
                          :disabled="loadingData"
                          color="primary"
                          id="add-email-company-button"
                        >
                          {{ $t('addEmailCompany') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row align="center">
                      <v-col cols="12">
                        <v-text-field
                          v-model="shareEmail"
                          :label="$t('email')"
                          required
                          id="share-email-address"
                          @keydown="checkKeyPress"
                        ></v-text-field>
                        <v-chip
                          v-for="email in emailList"
                          :key="email"
                          close
                          @click:close="removeEmail(email)"
                        >
                          {{ email }}
                        </v-chip>
                      </v-col>
                      <v-col cols="12">
                        <v-text-field
                          v-model="messageText"
                          :counter="200"
                          :label="$t('message')"
                          id="share-email-text"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      @click="shareNotification('email')"
                      :disabled="loadingData"
                      color="primary"
                      text
                      id="confirm-share-notif"
                    >
                      {{ $t('confirmShareEmail') }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
              <v-card v-else>
                <v-card-title class="text-h5 grey lighten-2">
                  {{ $t('noProcessPermissionTitle') }}
                </v-card-title>
                <v-card-text>
                  {{ $t('noProcessPermissionText') }}
                </v-card-text>
                <v-divider></v-divider>
              </v-card>
            </v-dialog>
          </v-card-actions>
        </div>

        <!-- Version Movil - mobile ------------------------------------------------>
        <div v-else>
          <div>
            <!-- Botones de navegacion -->
            <v-row
              v-if="!isSharedAccess && hasNavigation"
              class="mt-0 pt-0"
              align="center"
            >
              <v-col cols="3">
                <div class="ml-2 d-flex justify-space-between align-center">
                  <!-- Anterior ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-inline-flex">
                        <v-btn
                          elevation="1"
                          fab
                          small
                          class="secondary--text ma-1"
                          id="go-to-previous-notification"
                          :disabled="!hasPrevious"
                          color="primary"
                          @click.stop="goToPrevious"
                        >
                          <v-icon> mdi-chevron-left </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <p v-html="tooltipPreviousText" class="tooltip-text"></p>
                  </v-tooltip>

                  <!-- Siguiente ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on" class="d-inline-flex">
                        <v-btn
                          elevation="1"
                          fab
                          small
                          class="secondary--text ma-1"
                          id="go-to-next-notification"
                          :disabled="!hasNext"
                          color="primary"
                          @click.stop="goToNext"
                        >
                          <v-icon> mdi-chevron-right </v-icon>
                        </v-btn>
                      </div>
                    </template>
                    <p v-html="tooltipNextText" class="tooltip-text"></p>
                  </v-tooltip>

                  <!-- Volver ---->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        elevation="1"
                        fab
                        small
                        class="secondary--text ma-1"
                        v-bind="attrs"
                        v-on="on"
                        id="go-back-to-list"
                        color="primary"
                        @click.stop="goBackToList"
                      >
                        <v-icon> mdi-chevron-up </v-icon>
                      </v-btn>
                    </template>
                    <div>
                      {{ $t('goBackToList') }}
                    </div>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
          </div>

          <v-card-title>
            <v-col cols="12" align="center">
              <h3 class="primary--text">
                <v-icon x-large class="primary--text">mdi-identifier</v-icon
                >{{ notification.id }}
              </h3>
            </v-col>

            <v-row class="mt-3 d-flex justify-center">
              <v-col align="right">
                <AlertDialog
                  v-if="!isSharedAccess"
                  :asset="notification"
                  objectType="notifications"
                  :isDisabled="
                    isOperatorUser && !$store.state.user?.processNotification
                  "
                />
              </v-col>
            </v-row>

            <v-row class="mt-3 d-flex justify-center">
              <v-col align="left">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-if="isAdminUser && !isColectivoUser"
                      elevation="1"
                      fab
                      small
                      class="secondary--text ma-1"
                      v-bind="attrs"
                      v-on="on"
                      id="list-operators"
                      :disabled="loadingData"
                      :color="operatorsListFlag ? 'warning' : 'primary'"
                      @click.stop="switchOperatorsListFlag()"
                    >
                      <v-icon> mdi-account-group </v-icon>
                    </v-btn>
                  </template>
                  <div>
                    {{ $t('notificationProperties.showOperators') }}
                  </div>
                </v-tooltip>

                <NotificationMetadata
                  v-if="
                    (notification.metadatas ||
                      (notification.conceptoMetadatos &&
                        notification.conceptoMetadatos.length > 0 &&
                        notification.conceptoMetadatos[0] &&
                        Object.keys(notification.conceptoMetadatos[0]).length >
                          0)) &&
                    !isColectivoUser
                  "
                  :notification="notification"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-list dense>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" no-gutters>
                  <v-row align="center" no-gutters>
                    <v-col cols="6" no-gutters>
                      <span class="title">
                        {{ $t('notificationProperties.status') }}:
                      </span>
                    </v-col>
                    <v-col cols="6" align="end">
                      <v-chip
                        medium
                        class="white--text"
                        :color="getNotificationStatus(notification).color"
                      >
                        <span>
                          {{ $t(getNotificationStatus(notification).status) }}
                        </span>
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-3">
                <v-col cols="6">
                  <v-list-item-title class="title mr-4">
                    {{ $t('notificationProperties.notificationType') }}:
                  </v-list-item-title>
                </v-col>
                <v-col cols="6" align="end">
                  <v-icon medium color="primary">
                    {{ getNotificationType(notification).icon }}
                  </v-icon>
                  <span class="ml-1 body-1">
                    {{ $t(getNotificationType(notification).name) }}
                  </span>
                </v-col>
              </v-row>

              <!-- Concepto -->
              <v-row no-gutters class="mt-3">
                <v-col no-gutters>
                  <v-list-item-title class="title">
                    {{ $t('notificationProperties.concept') }}:
                  </v-list-item-title>
                  <span class="align-end">
                    {{ notification.concepto }}
                  </span>
                </v-col>
              </v-row>

              <!-- Responsable - modo movil - mobile -->
              <v-row no-gutters class="mt-3" v-if="!isSharedAccess">
                <v-col no-gutters>
                  <span class="title">
                    {{ $t('notificationProperties.manager') }}:
                  </span>
                  <template v-if="!isSharedAccess">
                    <div>
                      <template
                        v-if="
                          notification.managerAccepted === false &&
                          notification.manager
                        "
                      >
                        <v-col
                          v-if="
                            notification.manager.id !== $store.state.user?.id
                          "
                        >
                          <v-row>
                            <span class="body-1 text--secondary">
                              <div v-if="isGroup(notification.managerRef)">
                                {{ $t('waitGroupManager') }}
                              </div>
                              <div v-else>
                                {{ $t('waitManager') }}
                              </div>
                            </span>
                            <span
                              v-if="notification.manager.disabled"
                              class="body-1 text--secondary"
                            >
                              {{ $t('userDisabled') }}
                            </span>
                            <span
                              v-if="notification.canBeManager === false"
                              class="body-1 text--secondary"
                            >
                              {{ $t('operatorWithoutAccess') }}
                            </span>
                          </v-row>

                          <!-- Avatar + nombre en una linea, ancho completo -->
                          <v-row class="d-flex align-center w-100">
                            <!-- El tooltip de un Grupo se muestra sin transparencia -->
                            <v-tooltip
                              top
                              :content-class="
                                isGroup(notification.managerRef)
                                  ? 'tooltip-no-transparency'
                                  : ''
                              "
                              :z-index="
                                isGroup(notification.managerRef) ? 20 : 10
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="{
                                    ...on,
                                    mouseenter: (e) =>
                                      onActivatorMouseEnter(
                                        e,
                                        notification,
                                        on
                                      ),
                                  }"
                                >
                                  <AppAvatar
                                    v-if="notification.manager"
                                    class="ml-0"
                                    :userName="fullName(notification.manager)"
                                    :userAvatar="
                                      notification.manager?.avatarURL
                                    "
                                    :isGroup="isGroup(notification.managerRef)"
                                    :isDisabledOrDeleted="
                                      isGroup(notification.managerRef)
                                        ? notification.manager?.disabled ||
                                          notification.manager?.deleted
                                        : false
                                    "
                                    :avatarSize="
                                      isGroup(notification.managerRef)
                                        ? '34'
                                        : '30'
                                    "
                                    :initialsSize="
                                      isGroup(notification.managerRef) ? 11 : 14
                                    "
                                    iconSize="24"
                                    avatarColor="primary"
                                    initialsColor="secondary"
                                    :showWarn="
                                      notification.manager.disabled ||
                                      !notification.managerAccepted ||
                                      notification.manager.deleted ||
                                      notification.overlapIconColor ===
                                        'warning' ||
                                      notification.overlapIconColor === 'error'
                                    "
                                    __TODO_eliminar_:overlapIconColor="
                                    calculateOverlapIconColor(notification)
                                  "
                                    :overlapIconColor="
                                      notification.overlapIconColor
                                    "
                                  />
                                </span>
                              </template>

                              <!-- Contenido del tooltip -->
                              <div v-if="isGroup(notification.managerRef)">
                                <div>
                                  {{ $t('group') }}:
                                  {{ fullName(notification.manager) }}
                                  <b
                                    v-show="notification.manager.deleted"
                                    class="group-deleted"
                                  >
                                    {{ $t('groupDeleted') }}
                                  </b>
                                </div>
                              </div>
                              <div v-else>
                                {{ fullName(notification.manager) }}
                              </div>

                              <div v-if="!notification.managerAccepted">
                                <div v-if="isGroup(notification.managerRef)">
                                  {{ $t('waitGroupManager') }}
                                </div>
                                <div v-else>
                                  {{ $t('waitManager') }}
                                </div>
                              </div>

                              <div v-if="notification.manager.disabled">
                                {{ $t('userDisabled') }}
                              </div>
                              <div v-if="notification.canBeManager === false">
                                {{ $t('operatorWithoutAccess') }}
                              </div>

                              <div
                                v-if="
                                  notification.groupAccess?.summary
                                    ?.acceptedOperatorDeletedFromGroup
                                "
                                class="d-flex align-start"
                              >
                                <v-icon color="error" class="mr-2"
                                  >mdi-alert
                                </v-icon>
                                <div>
                                  <div>
                                    {{
                                      $t('acceptedOperatorDeletedFromGroup')
                                    }}:
                                  </div>
                                  <div>
                                    {{
                                      notification.groupAccess?.summary
                                        ?.acceptedOperatorDeletedFromGroupFullname
                                    }}
                                  </div>
                                </div>
                              </div>

                              <!--Mostrar lista de operadores del grupo responsable -->
                              <div v-if="isGroup(notification.managerRef)">
                                <div
                                  style="
                                    display: block;
                                    margin-top: 8px;
                                    margin-bottom: 10px;
                                  "
                                >
                                  {{ $t('groupOperators') }}:
                                </div>

                                <!-- estado: cargando -->
                                <div
                                  v-if="
                                    notification.groupAccess?.status !== 'ready'
                                  "
                                  class="tooltip-loading"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    size="20"
                                    width="2"
                                  />
                                </div>

                                <!-- estado: cargado -->
                                <template v-else>
                                  <!-- si hay operadores -->
                                  <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                  <ul
                                    v-if="
                                      getGroupOperators(notification).length
                                    "
                                  >
                                    <li
                                      v-for="(
                                        operator, index
                                      ) in getGroupOperatorsPreview(
                                        notification
                                      )"
                                      :key="index"
                                    >
                                      <v-row align="center">
                                        <AppAvatar
                                          class="mr-2 mt-3 mb-3"
                                          :userName="operator.fullName"
                                          :userAvatar="operator.avatarURL"
                                          avatarSize="30"
                                          iconSize="24"
                                          avatarColor="primary"
                                          initialsColor="secondary"
                                          :showWarn="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.hasError
                                          "
                                          :overlapIconColor="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.hasError
                                              ? 'error'
                                              : undefined
                                          "
                                        />
                                        <span class="mr-2 mt-3 mb-3">
                                          {{ operator.fullName }} :
                                          {{
                                            operatorAccessText(
                                              operator,
                                              notification
                                            )
                                          }}
                                          <template
                                            v-if="
                                              notification.groupAccess?.map[
                                                operator.id
                                              ]?.response.responded
                                            "
                                          >
                                            <v-icon
                                              :color="
                                                notification.groupAccess.map[
                                                  operator.id
                                                ].response.color
                                              "
                                              size="15"
                                              class="ml-1 mb-1"
                                            >
                                              mdi-circle
                                            </v-icon>
                                            {{
                                              notification.groupAccess.map[
                                                operator.id
                                              ].response.text
                                            }}
                                          </template>
                                        </span>
                                      </v-row>
                                    </li>
                                    <br />
                                  </ul>
                                  <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                  <div
                                    v-if="
                                      getGroupOperators(notification).length >
                                      maxOperatorsPreview
                                    "
                                    class="group-operators-info"
                                  >
                                    <v-chip
                                      small
                                      _color="grey lighten-4"
                                      _text-color="grey darken-3"
                                      color="primary"
                                      text-color="seconday"
                                      class="operator-count-chip"
                                    >
                                      +{{
                                        getGroupOperators(notification).length -
                                        maxOperatorsPreview
                                      }}
                                    </v-chip>
                                    <span class="operator-count-text">{{
                                      $t('groupOperators')
                                    }}</span>
                                  </div>

                                  <!-- estado: cargado pero grupo vacio -->
                                  <div
                                    v-if="
                                      !getGroupOperators(notification).length
                                    "
                                  >
                                    <ul>
                                      <li>{{ $t('withoutOperators') }}</li>
                                    </ul>
                                  </div>
                                </template>
                              </div>
                            </v-tooltip>

                            <span class="ml-1 body-1 text--secondary">
                              {{ fullName(notification.manager) }}
                            </span>

                            <v-btn
                              v-if="
                                !isOperatorUser ||
                                $store.state.user?.processNotification
                              "
                              small
                              icon
                              color="error"
                              @click="questionRemoveManager()"
                              id="remove-manager"
                            >
                              <v-icon> mdi-window-close </v-icon>
                            </v-btn>

                            <!-- nuevo boton por si se 'arrepiente' de haber rechazado -->
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-show="canAskAgain"
                                  elevation="1"
                                  fab
                                  small
                                  class="secondary--text ma-1"
                                  v-bind="attrs"
                                  v-on="on"
                                  id="ask-again"
                                  color="primary"
                                  @click="askAgainFlag = true"
                                >
                                  <v-icon>
                                    mdi-account-hard-hat-outline
                                  </v-icon>
                                </v-btn>
                              </template>
                              <div>
                                {{ $t('askResponsability.title') }}
                              </div>
                            </v-tooltip>
                          </v-row>
                        </v-col>

                        <v-row v-else>
                          <v-col cols="8">
                            <span class="body-1">
                              {{ $t('acceptResponsibility') }}
                            </span>
                          </v-col>
                          <v-col cols="4" class="d-flex justify-end">
                            <v-btn
                              class="mx-3"
                              color="primary"
                              icon
                              plain
                              @click="() => acceptNotification(notification)"
                            >
                              <v-icon>mdi-check</v-icon>
                            </v-btn>
                            <v-btn
                              class="mx-3"
                              color="error"
                              icon
                              plain
                              @click="() => declineNotification(notification)"
                            >
                              <v-icon>mdi-window-close</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </template>

                      <AppSkeleton
                        v-else-if="
                          !isOperatorUser ||
                          $store.state.user?.processNotification
                        "
                        :condition="loadingOperators"
                        type="assignManager"
                      >
                        <template v-slot:skeleton-content>
                          <div>
                            <!-- nuevo, al haber quitado el select y sustituirlo por un menu: -->
                            <!-- mostrar manager actual cuando está aceptado -->
                            <v-menu
                              v-model="menu"
                              offset-y
                              left
                              :close-on-content-click="false"
                              content-class="responsible-menu"
                              :nudge-bottom="4"
                              :max-height="370"
                              :min-width="500"
                            >
                              <!-- Activator = antiguo v-select -->
                              <template v-slot:activator="{ on, attrs }">
                                <v-row
                                  v-bind="attrs"
                                  v-on="on"
                                  align="center"
                                  no-gutters
                                  class="pa-2 pl-0"
                                  style="cursor: pointer"
                                >
                                  <!-- mostrar icono usuario solo si no esta aceptada la responsabilidad -->
                                  <v-icon
                                    v-if="!notification.managerAccepted"
                                    class="mr-2"
                                    >mdi-account</v-icon
                                  >

                                  <!-- contenedor unico tipo select -->
                                  <v-sheet
                                    v-bind="attrs"
                                    v-on="on"
                                    outlined
                                    rounded
                                    class="pa-2 d-flex align-center"
                                    style="cursor: pointer"
                                  >
                                    <!-- manager aceptado -->
                                    <template
                                      v-if="
                                        notification.manager &&
                                        notification.managerAccepted === true
                                      "
                                    >
                                      <!-- manager aceptado + mostrar tooltip -->
                                      <!-- El tooltip de un Grupo se muestra sin transparencia -->
                                      <v-tooltip
                                        top
                                        :content-class="
                                          isGroup(notification.managerRef)
                                            ? 'tooltip-no-transparency'
                                            : ''
                                        "
                                      >
                                        <template
                                          v-slot:activator="{ on, attrs }"
                                        >
                                          <span
                                            v-bind="attrs"
                                            v-on="{
                                              ...on,
                                              mouseenter: (e) =>
                                                onActivatorMouseEnter(
                                                  e,
                                                  notification,
                                                  on
                                                ),
                                            }"
                                          >
                                            <AppAvatar
                                              v-if="notification.manager"
                                              class="ml-0"
                                              :userName="
                                                fullName(notification.manager)
                                              "
                                              :userAvatar="
                                                notification.manager?.avatarURL
                                              "
                                              :isGroup="
                                                isGroup(notification.managerRef)
                                              "
                                              :isDisabledOrDeleted="
                                                isGroup(notification.managerRef)
                                                  ? notification.manager
                                                      ?.disabled ||
                                                    notification.manager
                                                      ?.deleted
                                                  : false
                                              "
                                              :avatarSize="
                                                isGroup(notification.managerRef)
                                                  ? '34'
                                                  : '30'
                                              "
                                              :initialsSize="
                                                isGroup(notification.managerRef)
                                                  ? 11
                                                  : 14
                                              "
                                              iconSize="24"
                                              avatarColor="primary"
                                              initialsColor="secondary"
                                              :showWarn="
                                                notification.manager.disabled ||
                                                !notification.managerAccepted ||
                                                notification.manager.deleted ||
                                                notification.overlapIconColor ===
                                                  'warning' ||
                                                notification.overlapIconColor ===
                                                  'error'
                                              "
                                              :overlapIconColor="
                                                notification.overlapIconColor
                                              "
                                            />
                                          </span>
                                        </template>

                                        <!-- Contenido del tooltip -->
                                        <div
                                          v-if="
                                            isGroup(notification.managerRef)
                                          "
                                        >
                                          <div>
                                            {{ $t('group') }}:
                                            {{ fullName(notification.manager) }}
                                            <b
                                              v-show="
                                                notification.manager.deleted
                                              "
                                              class="group-deleted"
                                            >
                                              {{ $t('groupDeleted') }}
                                            </b>
                                          </div>
                                        </div>
                                        <div v-else>
                                          {{ fullName(notification.manager) }}
                                        </div>

                                        <div
                                          v-if="!notification.managerAccepted"
                                        >
                                          <div
                                            v-if="
                                              isGroup(notification.managerRef)
                                            "
                                          >
                                            {{ $t('waitGroupManager') }}
                                          </div>
                                          <div v-else>
                                            {{ $t('waitManager') }}
                                          </div>
                                        </div>

                                        <div
                                          v-if="notification.manager.disabled"
                                        >
                                          {{ $t('userDisabled') }}
                                        </div>
                                        <div
                                          v-if="
                                            notification.canBeManager === false
                                          "
                                        >
                                          {{ $t('operatorWithoutAccess') }}
                                        </div>

                                        <div
                                          v-if="
                                            notification.groupAccess?.summary
                                              ?.acceptedOperatorDeletedFromGroup
                                          "
                                          class="d-flex align-start"
                                        >
                                          <v-icon color="error" class="mr-2"
                                            >mdi-alert
                                          </v-icon>
                                          <div>
                                            <div>
                                              {{
                                                $t(
                                                  'acceptedOperatorDeletedFromGroup'
                                                )
                                              }}:
                                            </div>
                                            <div>
                                              {{
                                                notification.groupAccess
                                                  ?.summary
                                                  ?.acceptedOperatorDeletedFromGroupFullname
                                              }}
                                            </div>
                                          </div>
                                        </div>

                                        <!--Mostrar lista de operadores del grupo responsable -->
                                        <div
                                          v-if="
                                            isGroup(notification.managerRef)
                                          "
                                        >
                                          <div
                                            style="
                                              display: block;
                                              margin-top: 8px;
                                              margin-bottom: 10px;
                                            "
                                          >
                                            {{ $t('groupOperators') }}:
                                          </div>

                                          <!-- estado: cargando -->
                                          <div
                                            v-if="
                                              notification.groupAccess
                                                ?.status !== 'ready'
                                            "
                                            class="tooltip-loading"
                                          >
                                            <v-progress-circular
                                              indeterminate
                                              size="20"
                                              width="2"
                                            />
                                          </div>

                                          <!-- estado: cargado -->
                                          <template v-else>
                                            <!-- si hay operadores -->
                                            <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                            <ul
                                              v-if="
                                                getGroupOperators(notification)
                                                  .length
                                              "
                                            >
                                              <li
                                                v-for="(
                                                  operator, index
                                                ) in getGroupOperatorsPreview(
                                                  notification
                                                )"
                                                :key="index"
                                              >
                                                <v-row align="center">
                                                  <AppAvatar
                                                    class="mr-2 mt-3 mb-3"
                                                    :userName="
                                                      operator.fullName
                                                    "
                                                    :userAvatar="
                                                      operator.avatarURL
                                                    "
                                                    avatarSize="30"
                                                    iconSize="24"
                                                    avatarColor="primary"
                                                    initialsColor="secondary"
                                                    :showWarn="
                                                      notification.groupAccess
                                                        ?.map[operator.id]
                                                        ?.hasError
                                                    "
                                                    :overlapIconColor="
                                                      notification.groupAccess
                                                        ?.map[operator.id]
                                                        ?.hasError
                                                        ? 'error'
                                                        : undefined
                                                    "
                                                  />
                                                  <span class="mr-2 mt-3 mb-3">
                                                    {{ operator.fullName }} :
                                                    {{
                                                      operatorAccessText(
                                                        operator,
                                                        notification
                                                      )
                                                    }}
                                                    <template
                                                      v-if="
                                                        notification.groupAccess
                                                          ?.map[operator.id]
                                                          ?.response.responded
                                                      "
                                                    >
                                                      <v-icon
                                                        :color="
                                                          notification
                                                            .groupAccess.map[
                                                            operator.id
                                                          ].response.color
                                                        "
                                                        size="15"
                                                        class="ml-1 mb-1"
                                                      >
                                                        mdi-circle
                                                      </v-icon>
                                                      {{
                                                        notification.groupAccess
                                                          .map[operator.id]
                                                          .response.text
                                                      }}
                                                    </template>
                                                  </span>
                                                </v-row>
                                              </li>
                                              <br />
                                            </ul>
                                            <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                            <div
                                              v-if="
                                                getGroupOperators(notification)
                                                  .length > maxOperatorsPreview
                                              "
                                              class="group-operators-info"
                                            >
                                              <v-chip
                                                small
                                                _color="grey lighten-4"
                                                _text-color="grey darken-3"
                                                color="primary"
                                                text-color="seconday"
                                                class="operator-count-chip"
                                              >
                                                +{{
                                                  getGroupOperators(
                                                    notification
                                                  ).length - maxOperatorsPreview
                                                }}
                                              </v-chip>
                                              <span
                                                class="operator-count-text"
                                                >{{
                                                  $t('groupOperators')
                                                }}</span
                                              >
                                            </div>
                                            <!-- estado: cargado pero grupo vacio -->
                                            <div
                                              v-if="
                                                !getGroupOperators(notification)
                                                  .length
                                              "
                                            >
                                              <ul>
                                                <li>
                                                  {{ $t('withoutOperators') }}
                                                </li>
                                              </ul>
                                            </div>
                                          </template>
                                        </div>
                                      </v-tooltip>

                                      <span class="body-1 text--secondary ml-2">
                                        {{ fullName(notification.manager) }}
                                      </span>

                                      <v-btn
                                        v-if="
                                          !isOperatorUser ||
                                          $store.state.user?.processNotification
                                        "
                                        color="error"
                                        icon
                                        small
                                        @click.stop="questionRemoveManager()"
                                      >
                                        <v-icon small>mdi-window-close</v-icon>
                                      </v-btn>
                                    </template>

                                    <!-- sin manager -->
                                    <span v-else class="body-1 text--secondary">
                                      {{ $t('assignManager') }}
                                    </span>

                                    <!-- spacer -->
                                    <v-spacer />

                                    <!-- flecha (para simular el append-icon del v-select antiguo) -->
                                    <v-icon>mdi-menu-down</v-icon>
                                  </v-sheet>
                                </v-row>
                              </template>

                              <!-- Menu de usuarios y grupos -->
                              <v-card>
                                <v-card-title>
                                  {{ $t('assignManagerNotification') }}
                                </v-card-title>
                                <v-card-text>
                                  <v-text-field
                                    v-model="managerSearch"
                                    clearable
                                    prepend-icon="mdi-magnify"
                                    :label="$t('searchField')"
                                    single-line
                                    hide-details
                                  />
                                  <v-divider class="mt-2 mb-2" />

                                  <!--Mostrar lista de posibles operadores asignables como responsable -->
                                  <v-row no-gutters>
                                    <v-col cols="6">
                                      <strong>{{ $t('operators') }}</strong>
                                      <!-- mostrar avatar y nombre de cada operador -->
                                      <v-list dense>
                                        <v-list-item
                                          v-for="manager in filteredPosibleManagers"
                                          :key="manager.id"
                                          @click="
                                            notification.managerRef
                                              ? setNewManager(
                                                  manager.id,
                                                  manager.fullName
                                                )
                                              : selectManager(manager.id)
                                          "
                                          :class="{
                                            'v-list-item--active primary--text v-list-item--highlighted':
                                              notification.managerRef?.id ===
                                              manager.id,
                                          }"
                                        >
                                          <AppAvatar
                                            class="mr-3"
                                            :userName="manager.fullName"
                                            :userAvatar="manager.avatarURL"
                                            avatarSize="30"
                                            iconSize="24"
                                            avatarColor="primary"
                                            initialsColor="secondary"
                                          />
                                          {{ manager.fullName }}
                                        </v-list-item>
                                      </v-list>
                                    </v-col>

                                    <!--Mostrar lista de posibles grupos asignables como responsable -->
                                    <v-col cols="6">
                                      <strong>{{
                                        $t('tabTitle.groups')
                                      }}</strong>
                                      <v-list dense>
                                        <v-list-item
                                          v-for="group in filteredPosibleGroups"
                                          :key="group.id"
                                          @click="
                                            notification.managerRef
                                              ? setNewGroup(
                                                  group.id,
                                                  group.fullName
                                                )
                                              : selectGroup(group.id)
                                          "
                                          :class="{
                                            'v-list-item--active primary--text v-list-item--highlighted':
                                              notification.managerRef?.id ===
                                              group.id,
                                          }"
                                        >
                                          <AppAvatar
                                            class="mr-3"
                                            :userName="group.fullName"
                                            :isGroup="true"
                                            avatarSize="34"
                                            :initialsSize="
                                              isGroup(notification.managerRef)
                                                ? 11
                                                : 14
                                            "
                                            iconSize="24"
                                            avatarColor="secondary"
                                            initialsColor="primary"
                                          />
                                          {{ group.fullName }}
                                        </v-list-item>
                                      </v-list>
                                    </v-col>
                                  </v-row>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                          </div>
                        </template>
                      </AppSkeleton>

                      <template v-else>
                        <div
                          v-if="notification.manager"
                          class="d-flex align-center justify-end w-100"
                        >
                          <!-- Avatar + nombre en una linea, ancho completo -->
                          <v-row class="d-flex align-center w-100 no-gutters">
                            <!-- El tooltip de un Grupo se muestra sin transparencia -->
                            <v-tooltip
                              top
                              :content-class="
                                isGroup(notification.managerRef)
                                  ? 'tooltip-no-transparency'
                                  : ''
                              "
                              :z-index="
                                isGroup(notification.managerRef) ? 20 : 10
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <span
                                  v-bind="attrs"
                                  v-on="{
                                    ...on,
                                    mouseenter: (e) =>
                                      onActivatorMouseEnter(
                                        e,
                                        notification,
                                        on
                                      ),
                                  }"
                                >
                                  <AppAvatar
                                    v-if="notification.manager"
                                    class="ml-0"
                                    :userName="fullName(notification.manager)"
                                    :userAvatar="
                                      notification.manager?.avatarURL
                                    "
                                    :isGroup="isGroup(notification.managerRef)"
                                    :avatarSize="
                                      isGroup(notification.managerRef)
                                        ? '34'
                                        : '30'
                                    "
                                    :initialsSize="
                                      isGroup(notification.managerRef) ? 11 : 14
                                    "
                                    iconSize="24"
                                    avatarColor="primary"
                                    initialsColor="secondary"
                                    :showWarn="
                                      notification.manager.disabled ||
                                      !notification.managerAccepted ||
                                      notification.manager.deleted ||
                                      notification.overlapIconColor ===
                                        'warning' ||
                                      notification.overlapIconColor === 'error'
                                    "
                                    :overlapIconColor="
                                      notification.overlapIconColor
                                    "
                                  />
                                </span>
                              </template>

                              <!-- Contenido del tooltip -->
                              <div v-if="isGroup(notification.managerRef)">
                                <div>
                                  {{ $t('group') }}:
                                  {{ fullName(notification.manager) }}
                                  <b
                                    v-show="notification.manager.deleted"
                                    class="group-deleted"
                                  >
                                    {{ $t('groupDeleted') }}
                                  </b>
                                </div>
                              </div>
                              <div v-else>
                                {{ fullName(notification.manager) }}
                              </div>

                              <div v-if="!notification.managerAccepted">
                                <div v-if="isGroup(notification.managerRef)">
                                  {{ $t('waitGroupManager') }}
                                </div>
                                <div v-else>
                                  {{ $t('waitManager') }}
                                </div>
                              </div>

                              <div v-if="notification.manager.disabled">
                                {{ $t('userDisabled') }}
                              </div>
                              <div v-if="notification.canBeManager === false">
                                {{ $t('operatorWithoutAccess') }}
                              </div>

                              <div
                                v-if="
                                  notification.groupAccess?.summary
                                    ?.acceptedOperatorDeletedFromGroup
                                "
                                class="d-flex align-start"
                              >
                                <v-icon color="error" class="mr-2"
                                  >mdi-alert
                                </v-icon>
                                <div>
                                  <div>
                                    {{
                                      $t('acceptedOperatorDeletedFromGroup')
                                    }}:
                                  </div>
                                  <div>
                                    {{
                                      notification.groupAccess?.summary
                                        ?.acceptedOperatorDeletedFromGroupFullname
                                    }}
                                  </div>
                                </div>
                              </div>

                              <!--Mostrar lista de operadores del grupo responsable -->
                              <div v-if="isGroup(notification.managerRef)">
                                <div
                                  style="
                                    display: block;
                                    margin-top: 8px;
                                    margin-bottom: 10px;
                                  "
                                >
                                  {{ $t('groupOperators') }}:
                                </div>

                                <!-- estado: cargando -->
                                <div
                                  v-if="
                                    notification.groupAccess?.status !== 'ready'
                                  "
                                  class="tooltip-loading"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    size="20"
                                    width="2"
                                  />
                                </div>

                                <!-- estado: cargado -->
                                <template v-else>
                                  <!-- si hay operadores -->
                                  <!-- mostrar avatar y nombre de los primeros N operadores del grupo -->
                                  <ul
                                    v-if="
                                      getGroupOperators(notification).length
                                    "
                                  >
                                    <li
                                      v-for="(
                                        operator, index
                                      ) in getGroupOperatorsPreview(
                                        notification
                                      )"
                                      :key="index"
                                    >
                                      <v-row align="center">
                                        <AppAvatar
                                          class="mr-2 mt-3 mb-3"
                                          :userName="operator.fullName"
                                          :userAvatar="operator.avatarURL"
                                          avatarSize="30"
                                          iconSize="24"
                                          avatarColor="primary"
                                          initialsColor="secondary"
                                          :showWarn="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.hasError
                                          "
                                          :overlapIconColor="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.hasError
                                              ? 'error'
                                              : undefined
                                          "
                                        />
                                        <span class="mr-2 mt-3 mb-3">
                                          {{ operator.fullName }} :
                                          {{
                                            operatorAccessText(
                                              operator,
                                              notification
                                            )
                                          }}
                                          <template
                                            v-if="
                                              notification.groupAccess?.map[
                                                operator.id
                                              ]?.response.responded
                                            "
                                          >
                                            <v-icon
                                              :color="
                                                notification.groupAccess.map[
                                                  operator.id
                                                ].response.color
                                              "
                                              size="15"
                                              class="ml-1 mb-1"
                                            >
                                              mdi-circle
                                            </v-icon>
                                            {{
                                              notification.groupAccess.map[
                                                operator.id
                                              ].response.text
                                            }}
                                          </template>
                                        </span>
                                      </v-row>
                                    </li>
                                    <br />
                                  </ul>
                                  <!-- Texto informativo, dentro del tooltip, cuando hay mas operadores de los mostrados -->
                                  <div
                                    v-if="
                                      getGroupOperators(notification).length >
                                      maxOperatorsPreview
                                    "
                                    class="group-operators-info"
                                  >
                                    <v-chip
                                      small
                                      _color="grey lighten-4"
                                      _text-color="grey darken-3"
                                      color="primary"
                                      text-color="seconday"
                                      class="operator-count-chip"
                                    >
                                      +{{
                                        getGroupOperators(notification).length -
                                        maxOperatorsPreview
                                      }}
                                    </v-chip>
                                    <span class="operator-count-text">{{
                                      $t('groupOperators')
                                    }}</span>
                                  </div>

                                  <!-- estado: cargado pero grupo vacio -->
                                  <div
                                    v-if="
                                      !getGroupOperators(notification).length
                                    "
                                  >
                                    <ul>
                                      <li>{{ $t('withoutOperators') }}</li>
                                    </ul>
                                  </div>
                                </template>
                              </div>
                            </v-tooltip>

                            <span class="body-1 text--secondary ml-2">
                              {{ fullName(notification.manager) }}
                            </span>
                          </v-row>
                        </div>

                        <v-list-item-content
                          class="align-end subtitle-1"
                          v-else
                        >
                          <span class="font-weight-black">
                            {{ $t('noManagerAssigned') }}
                          </span>
                        </v-list-item-content>
                      </template>
                    </div>

                    <!-- preguntar a un operador del grupo asignado si acepta o no la responsabilidad -->
                    <v-expand-transition>
                      <v-card
                        v-show="shouldShowResponsibilityCard"
                        class="mt-3 align-self-stretch responsibility-card"
                        :class="{ 'is-persistent': isQuestionPersistent }"
                        outlined
                      >
                        <v-card-title class="subtitle-1">
                          {{ $t('askResponsability.title') }}
                        </v-card-title>

                        <v-card-text class="body-2">
                          {{ $t('askResponsability.message') }}
                        </v-card-text>

                        <v-divider />

                        <v-card-actions class="justify-center">
                          <v-btn
                            color="primary"
                            text
                            @click="acceptResponsibilityQuestion"
                          >
                            {{ $t('askResponsability.accept') }}
                          </v-btn>

                          <v-btn
                            :disabled="askAgainFlag"
                            color="error"
                            text
                            @click="rejectResponsibilityQuestion"
                          >
                            {{ $t('askResponsability.reject') }}
                          </v-btn>

                          <v-btn
                            v-if="showAskLaterButton || askAgainFlag"
                            text
                            @click="askLaterResponsibilityQuestion"
                          >
                            {{ $t('askResponsability.askLater') }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-expand-transition>

                    <template>
                      <!-- Nuevo boton que indica que hay en total N operadores, cuando no caben todos en el tooltip -->
                      <!-- Nuevo menu para mostrar todos los operadores de un grupo, cuando no caben todos en el tooltip -->
                      <!-- contenedor de la fila del botón, reservamos espacio fijo para evitar saltos, -->
                      <!-- y usamos v-show para mostrar o no -->
                      <div class="group-operators-btn-wrapper">
                        <v-menu
                          v-model="menuAllGroupOperators"
                          offset-y
                          left
                          :close-on-content-click="false"
                          content-class="responsible-menu"
                          :nudge-bottom="4"
                          :max-height="350"
                          :min-width="500"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              text
                              small
                              class="ml-0 px-0"
                              color="primary"
                              v-show="showAllOperatorsButton"
                            >
                              {{
                                $t('seeThe') +
                                getGroupOperators(notification).length
                              }}
                              {{ $t('groupOperators') }}
                            </v-btn>
                          </template>

                          <v-card>
                            <v-card-text class="pa-2">
                              <v-text-field
                                v-model="operatorsSearch"
                                clearable
                                prepend-icon="mdi-magnify"
                                :label="$t('searchField')"
                                single-line
                                hide-details
                              />
                              <v-divider class="mt-2 mb-2" />

                              <!--Mostrar lista de todos los operadores del grupo -->
                              <v-row no-gutters>
                                <v-col>
                                  <strong>{{ $t('groupOperators') }}:</strong>
                                  <!-- mostrar avatar y nombre de cada operador -->
                                  <v-list dense>
                                    <v-list-item
                                      class="pl-0"
                                      v-for="operator in filteredGroupOperators"
                                      :key="operator.id"
                                    >
                                      <AppAvatar
                                        class="mr-3"
                                        :userName="operator.fullName"
                                        :userAvatar="operator.avatarURL"
                                        avatarSize="30"
                                        iconSize="24"
                                        avatarColor="primary"
                                        initialsColor="secondary"
                                        :showWarn="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                        "
                                        :overlapIconColor="
                                          notification.groupAccess?.map[
                                            operator.id
                                          ]?.hasError
                                            ? 'error'
                                            : undefined
                                        "
                                      />
                                      <span class="mr-2 mt-3 mb-3">
                                        {{ operator.fullName }} :
                                        {{
                                          operatorAccessText(
                                            operator,
                                            notification
                                          )
                                        }}
                                        <template
                                          v-if="
                                            notification.groupAccess?.map[
                                              operator.id
                                            ]?.response.responded
                                          "
                                        >
                                          <v-icon
                                            :color="
                                              notification.groupAccess.map[
                                                operator.id
                                              ].response.color
                                            "
                                            size="15"
                                            class="ml-1 mb-1"
                                          >
                                            mdi-circle
                                          </v-icon>
                                          {{
                                            notification.groupAccess.map[
                                              operator.id
                                            ].response.text
                                          }}
                                        </template>
                                      </span>
                                    </v-list-item>
                                  </v-list>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>
                        </v-menu>
                      </div>
                    </template>
                  </template>
                </v-col>
              </v-row>
              <!-- hasta aqui el Responsable ---->
            </v-container>

            <!-- Elementos desplegables -->
            <v-list-group append-icon="mdi-menu-down" fluid>
              <!-- Botón para desplegar la lista -->
              <template v-slot:activator>
                <v-row no-gutters>
                  <v-list-item-title class="title">
                    {{ $t('moreInfo') }}...
                  </v-list-item-title>
                </v-row>
              </template>

              <!-- Campo NIF -->
              <v-list-item>
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title mb-1">
                      {{ $t('notificationProperties.receiver') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      <span>{{ notification.nombre_titular }} </span>
                      <span
                        class="font-weight-black"
                        v-if="
                          !isEmptyNifTitular(notification) &&
                          !isIgnoredNifTitular(notification)
                        "
                      >
                        {{ notification.nif_titular }}
                      </span>

                      <!-- movil -->
                      <!-- Notificacion sin NIF Titular o marcado como IGNORAR-->
                      <v-flex
                        v-else-if="
                          isEmptyNifTitular(notification) ||
                          isIgnoredNifTitular(notification)
                        "
                        class="d-flex align-center mt-n2"
                      >
                        <span class="without-nif">
                          {{
                            isEmptyNifTitular(notification)
                              ? $t('notificationWithoutNifTitular')
                              : notification.nif_titular
                          }}
                        </span>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-if="isSuperAdminUser || isSuperOperatorUser"
                              @click="showEditNifDialog()"
                              color="primary"
                              class="secondary--text ma-2"
                              v-bind="attrs"
                              v-on="on"
                              id="edit-nif"
                              :disabled="loadingData"
                            >
                              <v-icon class="mr-2" dark> mdi-pencil </v-icon>
                              {{ $t('editNifButtonText') }}
                            </v-btn>
                          </template>
                          <span>
                            {{ $t('editNifButtonTooltip') }}
                          </span>
                        </v-tooltip>
                      </v-flex>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <!-- Campo ID Externo -->
              <v-list-item v-if="notification.origen !== 'MANUAL'">
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title mb-1">
                      {{
                        notification.origen === 'SEGSOCIAL'
                          ? $t('notificationProperties.idSegSocial')
                          : $t('notificationProperties.idDehu')
                      }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      <span>{{ notification.identificador }} </span>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <!-- Campo organismo emisor -->
              <v-list-item>
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title mb-1">
                      {{ $t('notificationProperties.orgSender') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      <span class="font-weight-black">
                        {{ notification.codigo_organismo_emisor }}
                      </span>
                      {{ notification.nombre_organismo_emisor }}
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <!-- Campo organismo emisor raíz -->
              <v-list-item>
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title mb-1">
                      {{ $t('notificationProperties.orgSenderSource') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      <span class="font-weight-black"
                        >{{ notification.codigo_organismo_emisor_raiz }}
                      </span>
                      <span
                        >{{ notification.nombre_organismo_emisor_raiz }}
                      </span>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <!-- Campo fecha puesta de disposición -->
              <v-list-item v-if="notification.fecha_puesta_disposicion">
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title">
                      {{ $t('notificationProperties.acceptSent') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      {{
                        $d(
                          new Date(notification.fecha_puesta_disposicion),
                          'i18nDateAndHourSeconds'
                        )
                      }}
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>

              <!-- Campo fecha aceptación -->
              <v-list-item v-if="notification.fecha_aceptacion">
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title">
                      {{ $t('notificationProperties.acceptDate') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      {{
                        $d(
                          new Date(notification.fecha_aceptacion),
                          'i18nDateAndHourSeconds'
                        )
                      }}
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                v-else-if="
                  notification.fecha_expiracion &&
                  notification.fecha_expiracion < new Date()
                "
              >
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title">
                      {{ $t('notificationProperties.expirationDate') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      {{
                        $d(
                          new Date(notification.fecha_expiracion),
                          'i18nDateAndHourSeconds'
                        )
                      }}
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                v-else-if="
                  notification.fecha_expiracion &&
                  notification.fecha_expiracion >= new Date()
                "
              >
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title">
                      {{ $t('notificationProperties.remaining') }}:
                    </span>
                    <v-list-item-content class="align-end subtitle-1">
                      <TimerCountdown
                        v-if="notification.fecha_puesta_disposicion"
                        :starttime="notification.fecha_puesta_disposicion"
                        :endtime="
                          new Date(
                            notification.fecha_puesta_disposicion
                          ).setDate(
                            new Date(
                              notification.fecha_puesta_disposicion
                            ).getDate() + 10
                          )
                        "
                        hideMessage="true"
                        from="NotificationPropertiesCard"
                      >
                      </TimerCountdown>
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
              <v-list-item
                v-if="
                  !isSharedAccess &&
                  (!isOperatorUser || $store.state.user?.processNotification)
                "
              >
                <v-container>
                  <v-row class="mb-2" justify="space-between" align="center">
                    <v-list-item-content class="title">
                      {{ $t('observation') }}:
                    </v-list-item-content>
                  </v-row>
                  <v-row class="mt-2" justify="space-between" align="center">
                    <v-list-item-content class="align-end subtitle-1">
                      <v-row no-gutters align="center">
                        <v-col cols="12">
                          <v-textarea
                            outlined
                            v-model="observation"
                            :rows="observation.length < 80 ? 4 : 6"
                            :class="[
                              'mb-0',
                              observation.length < 80 ? 'auto-grow' : '',
                            ]"
                            :value="notification.observation"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          v-if="
                            (notification.observation &&
                              observation !== notification.observation) ||
                            (!notification.observation && observation)
                          "
                        >
                          <v-btn
                            block
                            class="mt-n7"
                            color="primary"
                            @click.stop="confirmObservation()"
                          >
                            {{ $t('saveObservation') }}
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-row>
                </v-container>
              </v-list-item>
              <v-list-item v-else>
                <v-row no-gutters class="mt-2">
                  <v-col no-gutters>
                    <span class="title"> {{ $t('observation') }}: </span>
                    <v-list-item-content class="align-end subtitle-1">
                      {{ notification.observation }}
                    </v-list-item-content>
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list-group>
          </v-list>
          <v-progress-linear v-if="loadingData" indeterminate color="primary">
          </v-progress-linear>

          <!-- Dialog para abrir notificaciones -->
          <v-dialog
            v-if="!notification.document && !notification.isComparecida"
            v-model="dialog"
            width="320"
          >
            <v-card
              v-if="!isOperatorUser || $store.state.user?.downloadNotification"
            >
              <v-card-title class="text-h5 grey lighten-2">
                <v-container>
                  <v-row justify="space-between" align="center">
                    <span>
                      {{ $t('confirmAcceptanceTitle') }}
                    </span>
                    <v-btn fab @click="dialog = false" small plain>
                      <v-icon> mdi-close </v-icon>
                    </v-btn>
                  </v-row>
                </v-container>
              </v-card-title>
              <v-card-text class="pt-4">
                {{ $t('confirmAcceptanceText') }}
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  @click="confirmAcceptNotification()"
                  color="primary"
                  text
                >
                  {{ $t('confirmAcceptance') }}
                </v-btn>
              </v-card-actions>
            </v-card>
            <v-card v-else>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t('noDownloadPermissionTitle') }}
              </v-card-title>
              <v-card-text>
                {{ $t('noDownloadPermissionText') }}
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-dialog>
          <v-dialog v-model="shareDialog" width="500">
            <v-card
              v-if="!isOperatorUser || $store.state.user?.processNotification"
            >
              <v-tabs v-model="tab" fixed-tabs>
                <v-tab>{{ $t('link') }}</v-tab>
                <v-tab>{{ $t('email') }}</v-tab>
              </v-tabs>
              <v-form
                ref="shareForm"
                v-model="validShareForm"
                lazy-validation
                v-if="tab === 0"
              >
                <v-container>
                  <v-card-text>
                    {{ $t('confirmShareTextLink') }}
                  </v-card-text>
                  <v-text-field
                    v-model="shareIdentifier"
                    :counter="100"
                    :label="$t('shareIdentifier')"
                    required
                    :rules="shareIdentifierRules"
                    id="share-identifier"
                  ></v-text-field>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="shareNotification('link')"
                    :disabled="loadingData"
                    color="primary"
                    text
                    id="confirm-share-link-notif"
                  >
                    {{ $t('generateLink') }}
                    <v-icon class="ml-1" small> mdi-content-copy </v-icon>
                  </v-btn>
                </v-card-actions>
              </v-form>
              <v-form
                ref="shareForm"
                v-model="validShareForm"
                lazy-validation
                v-if="tab === 1"
              >
                <v-container>
                  <v-card-text>
                    {{ $t('confirmShareText') }}
                  </v-card-text>
                  <v-row align="center">
                    <v-col cols="12">
                      <v-text-field
                        v-model="shareEmail"
                        :label="$t('email')"
                        required
                        id="share-email"
                        @keydown="checkKeyPress"
                      ></v-text-field>
                      <v-chip
                        v-for="email in emailList"
                        :key="email"
                        close
                        @click:close="removeEmail(email)"
                      >
                        {{ email }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="messageText"
                        :counter="200"
                        :label="$t('message')"
                        id="share-email-text"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>

                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    @click="shareNotification('email')"
                    :disabled="loadingData"
                    color="primary"
                    text
                    id="confirm-share-notif"
                  >
                    {{ $t('confirmShareEmail') }}
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
            <v-card v-else>
              <v-card-title class="text-h5 grey lighten-2">
                {{ $t('noProcessPermissionTitle') }}
              </v-card-title>
              <v-card-text>
                {{ $t('noProcessPermissionText') }}
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-dialog>

          <!-- Botones abrir, compartir y adjuntar archivos -->
          <v-card-actions v-if="notification && !isSharedAccess" class="p-0">
            <v-row no-gutters justify="center" align="center">
              <v-btn
                v-if="!notification.document && !notification.isComparecida"
                color="primary"
                class="ma-2 secondary--text"
                @click="dialog = true"
              >
                {{ $t('openNotification') }}
                <v-icon right dark> mdi-lock-open-variant-outline </v-icon>
              </v-btn>
              <v-btn
                v-if="
                  !notification.document &&
                  notification.isComparecida &&
                  userCanAttach
                "
                @click="addDocsDialog = true"
                color="primary"
                class="ma-2 secondary--text"
              >
                <v-icon dark> mdi-file-document-plus-outline </v-icon>
                {{ $t('attachFiles') }}
              </v-btn>
              <v-btn
                v-if="userCanChangeStatus"
                @click="changeStatusDialog = true"
                color="primary"
                class="ma-2 secondary--text"
              >
                <v-icon dark> mdi-swap-horizontal </v-icon>
                {{ $t('changeStatus') }}
              </v-btn>
              <v-btn
                @click="shareDialog = true"
                color="blue-grey"
                class="my-4"
                icon
              >
                <v-icon dark> mdi-share </v-icon>
              </v-btn>
            </v-row>
          </v-card-actions>
        </div>
      </template>
    </AppSkeleton>
    <AddDocsDialog
      :notification="notification"
      @closeAddDocsDialog="closeAddDocsDialog"
      v-if="addDocsDialog && userCanAttach"
    />
    <ChangeStatusDialog
      :notification="notification"
      @closeChangeStatusDialog="closeChangeStatusDialog"
      v-if="changeStatusDialog && userCanChangeStatus"
    />
    <OperatorsGridModal
      :operators="operatorsCanView"
      :showDialog="operatorsListFlag"
      :title="$t('notificationProperties.operatorsTitle')"
      @dialog-closed="closeGrid"
      v-if="operatorsListFlag"
    />
    <CifsGridModal
      v-if="(isSuperAdminUser || isSuperOperatorUser) && editNifDialog"
      :cifs="cifsList"
      :showDialog="editNifDialog"
      :showIgnoreButton="
        this.isIgnoredNifTitular(this.notification) ? false : true
      "
      @edit-nif-dialog-cancel="closeCifsGrid"
      @edit-nif-dialog-confirm="assignNifTitular"
    />
    <RemoveManagerDialog
      v-if="showRemoveManagerDialog"
      :fullName="fullName(notification.manager)"
      :isGroup="isGroup(notification.managerRef)"
      @removeManagerChoice="confirmRemoveManager"
    />
    <ChangeManagerDialog
      v-if="showChangeManagerDialog"
      :fullName="fullName(notification.manager)"
      :isGroup="isGroup(notification.managerRef)"
      :fullNameTarget="changeNewManager.fullName"
      :isGroupTarget="changeNewManager.type === 'group' ? true : false"
      @changeManagerChoice="confirmChangeManager"
    />
  </v-card>
</template>

<script>
import {
  getNotificationStatus,
  getNotificationType,
  acceptNotification,
  synchronizeNotification,
  assignManager,
  possibleManagers,
  possibleGroups,
  managerAcceptNotification,
  managerDeclineNotification,
  updateObservation,
  operatorsCanViewNotification,
  updateNifTitular,
  canOperatorBeManagerWithFilters,
  canOperatorBeManager,
  saveOperatorResponse,
} from '@/services/notification-service'
import {
  createShareCode,
  createShareCodeLink,
} from '@/services/share-codes-service'
import { mapMutations } from 'vuex'
import rules from '@/utils/rules'
import {
  getOperatorsSubscriptionReduced,
  withHeavyCache,
  clearOperatorsHeavyCache,
  GetDocumentFromReference,
} from '@/services/operator-service'
import AlertDialog from '@/components/alert/AlertDialog'
import { mapGetters } from 'vuex'
import getErrorText from '@/utils/get-error-text'
import TimerCountdown from '@/components/commons/TimerCountdown'
import { createTrace } from '@/services/trace-service'
import { getUser, getUserRef, isGroupRef } from '@/services/user-service'
import { validateCompanyByCif } from '@/services/user-service'
import AddDocsDialog from './AddDocsDialog.vue'
import ChangeStatusDialog from './ChangeStatusDialog.vue'
import NotificationMetadata from './NotificationMetadata.vue'
import OperatorsGridModal from '@/components/operators/OperatorsGridModal'
import CifsGridModal from '@/components/cifs/CifsGridModal'
import RemoveManagerDialog from '@/components/notifications/dialog/RemoveManagerDialog'
import ChangeManagerDialog from '@/components/notifications/dialog/ChangeManagerDialog'
import { listCifs } from '@/services/cifs-service'
import { getGroupsSubscription } from '@/services/groups-service'

export default {
  props: {
    notificationProp: Object,
    loadingNotification: Boolean,
    isSharedAccess: Boolean,
    shared: Array,
    allowAskLater: {
      type: Boolean,
      default: true,
    },
    isQuestionPersistent: {
      type: Boolean,
      default: false, //TODO Fase II aun por hacer
    },
  },
  components: {
    AlertDialog,
    TimerCountdown,
    AddDocsDialog,
    ChangeStatusDialog,
    NotificationMetadata,
    OperatorsGridModal,
    CifsGridModal,
    RemoveManagerDialog,
    ChangeManagerDialog,
  },
  watch: {
    notificationProp: {
      immediate: true,
      handler(newVal) {
        this.notification = { ...newVal }
      },
    },
    //
    async notification(newValue, oldValue) {
      if (newValue) {
        this.observation = this.notification.observation
          ? this.notification.observation
          : ''
        if (!this.isSharedAccess) {
          // Si es operador pasamos el parent
          const parentUserId = this.isOperatorUser
            ? this.$store.state.user.parentRef.id
            : this.$store.state.user.id
          const parentUser = await getUser(parentUserId)

          if (newValue._loadingGroupData === undefined) {
            await this.loadGroupData(newValue)
            this.loadingOperators = false
          }

          // cambios realmente relevantes
          if (
            newValue.managerAccepted !== oldValue.managerAccepted ||
            (newValue.responseOperators?.length ?? 0) !==
              (oldValue.responseOperators?.length ?? 0) ||
            newValue.manager?.disabled !== oldValue.manager?.disabled ||
            newValue.manager?.deleted !== oldValue.manager?.deleted
          ) {
            this.loadGroupData(newValue, {
              forceReset: true,
              showLoading: true,
            })
          }

          this.posibleManagers = possibleManagers(
            this.operators,
            newValue,
            parentUser
          )

          // Filtrar los grupos posibles que se pueden asignar a esta notificacion
          this.posibleGroups = await possibleGroups(this.groups, newValue)

          this.loadingOperators = false // TODO revisar esto
        }

        if (!this.refreshed) {
          await this.refreshIfNeeded()
          this.refreshed = true
        }
        if (newValue.document && newValue.document['enlace_documento']) {
          this.docLink = newValue.document['enlace_documento']
        }
      }
      this.getManager()
    },
    menu(open) {
      // Limpieza automatica de las busquedas al cerrar el menu
      if (!open) {
        this.managerSearch = ''
      }
    },
    menuAllGroupOperators(open) {
      // Limpieza automatica de las busquedas al cerrar el menu
      if (!open) {
        this.operatorsSearch = ''
      }
    },
    operators: {
      async handler(newVal, oldVal) {
        if (!oldVal || newVal === oldVal) return
        if (!this.notification) return
        if (this.loadingGroupData) return

        // los operadores suscritos han cambiado, recalcula accesos sobre la notificacion actual
        this.loadingGroupData = true

        // averiguar qué operador ha cambiado y en que afecta (name, surname, disabled ...) porque la
        // mayoria de atributos no influyen en esto
        let changed = null
        for (const op of newVal) {
          const prev = oldVal.find((item) => item.id === op.id)
          if (!prev) {
            // operador nuevo, añadido
            continue
          }

          const prevMap = prev.cifsPermissions || {}
          const nextMap = op.cifsPermissions || {}
          // Detectar borrado de claves en el mapa cifsPermissions, lo que significa empresa borrada al operador
          const removed = Object.keys(prevMap).filter((k) => !(k in nextMap))
          // Detectar nuevas claves en el mapa cifsPermissions, lo que significa empresa añadida al operador
          const added = Object.keys(nextMap).filter((k) => !(k in prevMap))

          if (
            prev.fullName !== op.fullName ||
            prev.disabled !== op.disabled ||
            removed.length > 0 ||
            added.length > 0
          ) {
            changed = op
            break
          }
        }
        if (!changed) return

        const operatorsMap = this.operatorsMap
        try {
          // recarga el manager si el operador es responsable directo
          if (
            this.notification.managerRef &&
            this.notification.managerRef.id === changed.id
          ) {
            const newManager =
              operatorsMap[this.notification.managerRef.id] ??
              (await GetDocumentFromReference(this.notification.managerRef))

            this.notification.manager = newManager
            // actualiza el cambio en el store mediante una nueva mutacion
            this.$store.commit('updateNotificationManager', {
              id: this.notification.id,
              manager: newManager,
            })

            await this.loadGroupData(this.notification)
          }
        } finally {
          this.loadingGroupData = false
        }

        // Caso el responsable es un operador:
        // filtrar aquellas notificaciones cuyo managerRef.id sea === al id del operador que ha cambiado, y
        // luego actualizar unicamente ese conjunto de notificaciones, no todas.
        await Promise.all(
          this.$store.state.notifications
            .filter((item) => item.managerRef?.id === changed.id)
            .map(async (doc) => {
              const newManager =
                operatorsMap[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              doc.manager = newManager
              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })
            })
        )
      },
    },
    groups: {
      async handler(newVal, oldVal) {
        if (!Array.isArray(newVal) || !Array.isArray(oldVal)) {
          return
        }
        if (!this.notification) return

        // recalcula los grupos seleccionables
        this.posibleGroups = await possibleGroups(newVal, this.notification)

        // recarga el manager con cualquier posible cambio
        if (this.isGroup(this.notification.managerRef)) {
          this.notification.manager = await GetDocumentFromReference(
            this.notification.managerRef
          )
        }
        await this.loadGroupData(this.notification)

        // actualiza todas las notificaciones que puedan haber cambiado debido a que
        // los grupos suscritos han cambiado
        // averiguar qué grupo ha cambiado y en que afecta (name, deleted ...)
        let changed = null
        for (const grp of newVal) {
          const prev = oldVal.find((item) => item.id === grp.id)
          if (!prev) {
            // grupo nuevo, añadido
            continue
          }

          if (this.hasGroupChanged(prev, grp)) {
            changed = grp
            break
          }
        }
        if (!changed) return

        const groupsById = {}
        for (const g of this.groups) {
          groupsById[g.id] = g // a diferencia del mapa groupsOperatorsMap, esto si contiene todo el objeto completo suscrito.
        }

        await Promise.all(
          this.$store.state.notifications
            .filter((item) => item.managerRef?.id === changed.id)
            .map(async (doc) => {
              const newManager =
                groupsById[doc.managerRef.id] ??
                (await GetDocumentFromReference(doc.managerRef))

              // actualiza el cambio en el store mediante una nueva mutacion
              this.$store.commit('updateNotificationManager', {
                id: doc.id,
                manager: newManager,
              })
            })
        )
      },
    },
    groupsOperatorsMap: {
      immediate: true,
      handler(map) {
        if (!map) return
        if (!this.notification) return
        if (this.notification.managerRef) {
          this.loadGroupData(this.notification, {
            forceReset: true,
            showLoading: true,
          })
        }
      },
    },
  },
  async beforeMount() {
    const userId = this.isOperatorUser
      ? this.$store.state.user.parentRef.id
      : this.$store.state.user.id

    this.operatorsUnsubscribe = await getOperatorsSubscriptionReduced(
      userId,
      this
    )

    this.groupsUnsubscribe = await getGroupsSubscription(this)
  },
  async destroyed() {
    if (this.operatorsUnsubscribe) {
      this.operatorsUnsubscribe()
      clearOperatorsHeavyCache()
    }
    if (this.groupsUnsubscribe) this.groupsUnsubscribe()
  },
  async mounted() {
    this.getManager()
    await this.refreshIfNeeded()
  },
  data() {
    return {
      selectedOperator: null,
      loadingData: false,
      posibleManagers: [],
      emailList: [],
      dialog: false,
      shareDialog: false,
      addDocsDialog: false,
      changeStatusDialog: false,
      loadingOperators: true,
      shareEmail: '',
      shareIdentifier: '',
      validShareForm: false,
      messageText: '',
      tab: 0,
      observation: '',
      editingObservation: false,
      shareIdentifierRules: [() => this.shareIdentifier !== ''],
      emailRules: [rules.required, rules.email],
      operatorsListFlag: false,
      usersOperators: [],
      notificationsWithOperators: [],
      managerSearch: '',
      refreshed: false,
      docLink: '',
      editNifDialog: false,
      cifsList: [],
      //
      menu: false,
      selectedManagerType: null, // establece 'user' o 'group',
      loadingGroupData: false,
      responsabilityQuestionResponse: '',
      askAgainFlag: false,
      menuAllGroupOperators: false,
      operatorsSearch: '',
      posibleGroups: [],
      notification: { ...this.notificationProp },
      showRemoveManagerDialog: false,
      showChangeManagerDialog: false,
      changeNewManager: {},
      operatorsUnsubscribe: () => {},
      groupsUnsubscribe: () => {},
      operators: [],
      groups: null,
    }
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdminUser',
      'isOperatorUser',
      'isColectivoUser',
      'isSuperAdminUser',
      'isSuperOperatorUser',
      'isSubstituteMode',
      'maxOperatorsPreview',
      'isAdminAndCanManageCompanies',
      'isInGroupUser',
      'isAdminAndCanManageGroups',
      'setNotificationNavIndex',
    ]),
    filteredPosibleManagers() {
      return this.filteredByManagerSearch(this.posibleManagers)
    },
    filteredPosibleGroups() {
      return this.filteredByManagerSearch(this.posibleGroups)
    },
    userCanAttach() {
      /*
      Desde que existe DEHUC, no permitimos por defecto subir una notificación comparecida ya que puede dar conflicto
      de archivos al obtenerse por el DEHUC posteriormente (principalmente si coincide la subida con el trabajo del job)
      Pero para casos de incidencias que los ficheros no se han obtenidos (principalmente enlaces extraños), para permitir
      que se agreguen manualmente, habría que establecer a mano a la notificación a true los flag isComparecida y allowedAttach
      */
      return (
        (!this.isOperatorUser ||
          this.$store.state.user.processNotification ||
          this.$store.state.user.downloadNotification) &&
        this.notification.allowedAttach
      )
    },
    userCanChangeStatus() {
      return (
        this.notification.document &&
        (this.isAdminUser ||
          this.$store.state.user?.processNotification ||
          (!this.isAdminUser &&
            this.notification.manager &&
            this.notification.manager.id === this.$store.state.user?.id))
      )
    },
    operatorsCanView() {
      return this.notificationsWithOperators[0]?.operators
    },
    selectedLabel() {
      if (!this.selectedOperator) return ''
      return this.selectedManagerType === 'group'
        ? this.selectedOperator.fullName
        : this.selectedOperator.fullName
    },
    userRef() {
      // expediente-X , algunos usuarios no contienen la prop user.ref en el store ??
      if (this.$store.state.user?.ref) return this.$store.state.user?.ref
      return getUserRef(this.$store.state.user.id)
    },
    hasResponded() {
      return this.hasOperatorResponded(this.notification, this.userRef)
    },
    belongsToGroup() {
      return this.checkIfUserBelongsToGroup(this.userRef)
    },
    shouldShowResponsibilityCard() {
      return (
        (this.showResponsibilityQuestion &&
          !this.responsabilityQuestionResponse) ||
        this.askAgainFlag
      )
    },
    showResponsibilityQuestion() {
      return (
        !this.notification.managerAccepted &&
        this.isGroup(this.notification.managerRef) &&
        this.belongsToGroup &&
        !this.hasResponded
      )
    },
    showAskLaterButton() {
      return !this.isQuestionPersistent && this.allowAskLater
    },
    canAskAgain() {
      return (
        !this.notification.managerAccepted &&
        this.isGroup(this.notification.managerRef) &&
        this.getLatestOperatorResponse(this.userRef)?.response === false &&
        this.checkIfUserBelongsToGroup(this.userRef) &&
        !this.notification.manager.deleted
      )
    },
    showAllOperatorsButton() {
      return (
        this.isGroup(this.notification.managerRef) &&
        this.getGroupOperators(this.notification).length >
          this.maxOperatorsPreview &&
        Object.keys(this.notification?.groupAccess?.map ?? {}).length
      )
    },
    filteredGroupOperators() {
      const operators = this.getGroupOperators(this.notification) || []

      const filtered = this.operatorsSearch
        ? operators.filter((op) =>
            op.fullName
              .toLowerCase()
              .includes(this.operatorsSearch.toLowerCase())
          )
        : operators

      return this.sortOperatorsByFullName(filtered)
    },
    operatorsMap() {
      const map = {}
      for (const operator of this.operators || []) {
        map[operator.id] = operator
      }
      return map
    },
    groupsOperatorsMap() {
      const map = {}
      if (!this.groups?.length) return map

      for (const group of this.groups || []) {
        // guardamos solo los ids de los operadores del grupo y un par de metadatos, nada de objetos
        map[group.id] = {
          operatorIds: (group.usersRef || []).map((ref) => ref.id),
          deleted: group.deleted,
          name: group.fullName,
        }
      }
      return map
    },
    nav() {
      return (
        this.$store.state.notificationNav ?? {
          ids: [],
          index: -1,
        }
      )
    },
    hasPrevious() {
      return this.nav.index > 0
    },
    hasNext() {
      return this.nav.index >= 0 && this.nav.index < this.nav.ids.length - 1
    },
    hasNavigation() {
      return this.nav.ids.length > 0
    },
    tooltipPreviousText() {
      // Si hay anterior, mensaje normal
      if (this.hasPrevious) {
        return this.$t('goToPrevious')
      }

      // No hay anterior
      if (this.userHasSorted) {
        return this.$t('goToPreviousSortedEnd') // Primer elemento de la pagina actual
      }

      // Primer elemento real del listado, sin ordenacion del usuario
      return this.$t('goToPreviousEnd')
    },
    tooltipNextText() {
      // Si hay siguiente, mensaje normal
      if (this.hasNext) {
        return this.$t('goToNext')
      }

      // No hay siguiente
      if (this.userHasSorted) {
        return this.$t('goToNextSortedEnd') // Ultimo elemento de la pagina actual
      }

      // Ultimo elemento real del listado, sin ordenacion del usuario
      return this.$t('goToNextEnd')
    },
    userHasSorted() {
      // Comprueba si el usuario ha reordenado el listado
      const optionsSaved = this.$store.state.notificationsListOptions
      return (
        optionsSaved.sortBy?.length > 0 || optionsSaved.sortDesc?.length > 0
      )
    },
  },
  methods: {
    ...mapMutations(['setDialog', 'setSnackbar']),
    checkKeyPress(event) {
      if (event.key === ' ' || event.key === ',' || event.key === 'Enter') {
        event.preventDefault()
        return this.addEmail()
      }
    },
    addEmail() {
      const email = this.shareEmail.trim()
      if (email.length > 0 && !this.emailList.includes(email)) {
        if (this.validateAddress(email)) this.emailList.push(email)
        else {
          const message = this.$t('invalidEmail')
          this.setSnackbar({ position: 'top', type: 'error', message })
          return false
        }
      }
      this.shareEmail = ''
      return true
    },
    removeEmail(email) {
      const index = this.emailList.indexOf(email)
      if (index !== -1) {
        this.emailList.splice(index, 1)
      }
    },
    async confirmObservation() {
      if (this.notification.observation !== this.observation) {
        await updateObservation(this.notification.id, this.observation)

        const message = this.$t('observationUpdatedSuccessfully')
        this.setSnackbar({ position: 'top', type: 'success', message })
      }

      this.editingObservation = false
    },
    closeAddDocsDialog() {
      this.addDocsDialog = false
    },
    closeChangeStatusDialog() {
      this.changeStatusDialog = false
    },
    async copyURL(linkID) {
      const userId = this.isOperatorUser
        ? this.$store.state.user.parentRef.id
        : this.$store.state.user.id
      try {
        await navigator.clipboard.writeText(
          window.location.origin +
            '/sharedNotification/' +
            userId +
            '/' +
            this.notification.id +
            '/' +
            linkID
        )

        const message = this.$t('sharedLinkClipboardSuccessfully')
        this.setSnackbar({ position: 'top', type: 'success', message })
      } catch {
        const message = this.$t('sharedLinkClipboardError')
        this.setSnackbar({ position: 'top', type: 'error', message })
      }
    },
    getNotificationStatus(notification) {
      return getNotificationStatus(notification)
    },
    getNotificationType(notification) {
      return getNotificationType(notification)
    },
    getManager() {
      this.selectedOperator = this.notification.manager
        ? this.notification.manager.id
        : null
    },
    async assignManager() {
      await assignManager(
        this.notification.id,
        this.selectedOperator,
        this.selectedOperator === this.$store.state.user.id,
        this.selectedManagerType
      )
      // TODO: Saved in case we need to track notification MANAGER
      // await createTrace(this.$store.state.user.id, {
      //   actionType: 'assignManager',
      //   manager: this.selectedOperator,
      //   createdAt: new Date(),
      //   notificationId: this.notification.id,
      // })
    },
    questionRemoveManager() {
      this.showRemoveManagerDialog = true
    },
    async confirmRemoveManager(response) {
      this.showRemoveManagerDialog = false // Cerrar el diálogo
      if (response === 'accept') {
        // Si el usuario acepta, continuar con la actualización
        await this.removeManager()
      }
    },
    async removeManager() {
      await assignManager(this.notification.id)
      this.selectedOperator = null

      // TODO: Saved in case we need to track notification MANAGER
      // await createTrace(this.$store.state.user.id, {
      //   actionType: 'removedManager',
      //   manager: this.selectedOperator,
      //   createdAt: new Date(),
      //   notificationId: this.notification.id,
      // })
    },
    setNewManager(id, fullName) {
      if (id === this.notification.managerRef?.id) return
      this.changeNewManager = { id: id, type: 'user', fullName: fullName }
      this.questionChangeManager()
    },
    setNewGroup(id, fullName) {
      if (id === this.notification.managerRef?.id) return
      this.changeNewManager = { id: id, type: 'group', fullName: fullName }
      this.questionChangeManager()
    },
    questionChangeManager() {
      this.showChangeManagerDialog = true
    },
    async confirmChangeManager(response) {
      this.showChangeManagerDialog = false // Cerrar el diálogo
      if (response === 'accept') {
        // Si el usuario acepta, continuar con la actualización
        if (this.changeNewManager.type === 'user') {
          await this.selectManager(this.changeNewManager.id)
        } else if (this.changeNewManager.type === 'group') {
          await this.selectGroup(this.changeNewManager.id)
        }
      }
      this.changeNewManager = null
    },
    async shareNotification(type) {
      if (!this.$refs.shareForm?.validate()) {
        return
      }
      try {
        if (type === 'email') {
          if (this.emailList.length === 0 && !this.shareEmail) return
          // Check previo de validacion de correos electronicos

          // Añadimos en cualquier caso el email que esta escrito en el v-text-field,
          // sin tener que escribir coma y espacio
          this.emailList =
            this.emailList.length === 0
              ? this.shareEmail
                ? [this.shareEmail]
                : []
              : [...this.emailList, this.shareEmail].filter(Boolean)

          // Se realiza una segunda comprobacion de mails válidos
          const allEmailsValid = this.emailList.every((address) =>
            this.validateAddress(address)
          )

          if (!allEmailsValid) {
            const message = this.$t('invalidEmail')
            this.setSnackbar({ position: 'top', type: 'error', message })
            this.emailList = []
            this.shareEmail = ''
            return
          }
        }
        this.shareDialog = false
        this.loadingData = true

        const sharedCode =
          type == 'link'
            ? await createShareCodeLink(
                this.notification.id,
                this.shareIdentifier
              )
            : await createShareCode(
                this.notification.id,
                this.emailList,
                this.messageText
              )
        //TODO: Saved in case we need to track notification SHARING
        // const sharedCode = ''
        // type == 'link'
        //   ? await createTrace(this.$store.state.user.id, {
        //     actionType: 'createdShareLink',
        //     createdAt: new Date(),
        //     notificationId: this.notification.id,
        //   })
        //   : await createTrace(this.$store.state.user.id, {
        //     actionType: 'createdShareCode',
        //     createdAt: new Date(),
        //     notificationId: this.notification.id,
        //   })

        this.$refs.shareForm?.reset()
        this.loadingData = false
        this.emailList = []
        this.shareEmail = ''
        // Copy to clipboard
        if (type == 'link') this.copyURL(sharedCode.id)

        const message = this.$t('sharedNotificationSuccess')
        this.setSnackbar({ position: 'top', type: 'success', message })
      } catch (err) {
        this.loadingData = false
        const message = this.$t('sharedNotificationError')
        this.setSnackbar({ position: 'top', type: 'error', message })
      }
    },
    validateAddress(address) {
      const regex =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

      return regex.test(address)
    },
    async confirmAcceptNotification() {
      try {
        this.dialog = false
        this.loadingData = true
        const absentUser = this.isSubstituteMode ? this.$store.state.user : null
        await acceptNotification(this.notification, absentUser)
        // Contemplar modo sustitucion: registrar en las trazas del operador sustituto cuando esta en modo sustitucion
        await createTrace(
          this.isSubstituteMode
            ? this.$store.state.userSubstitute.id
            : this.$store.state.user.id,
          {
            actionType: 'openNotification',
            createdAt: new Date(),
            notificationId: this.notification.id,
            notificationConcept: this.notification.concepto || '',
            ...(this.isSubstituteMode
              ? {
                  absentUserRef: getUserRef(this.$store.state.user.id),
                }
              : {}),
          }
        )
        this.loadingData = false
      } catch (err) {
        this.loadingData = false
        const message = getErrorText(err.toString())
        this.setSnackbar({
          timeout: '20000',
          position: 'top',
          type: 'warning',
          message,
        })
      }
    },
    async acceptNotification(notification) {
      await managerAcceptNotification(notification.id)
    },
    async declineNotification(notificacion) {
      await managerDeclineNotification(notificacion.id)
    },
    async switchOperatorsListFlag() {
      if (!this.operatorsListFlag) {
        this.loadingData = true
        // refactor reducir consumo de memoria
        this.notificationsWithOperators = await operatorsCanViewNotification(
          this.operators,
          [this.notification]
        )

        await new Promise((r) => setTimeout(r, 100))
        this.loadingData = false
      }
      this.operatorsListFlag = !this.operatorsListFlag
    },
    async getCompanyEmail() {
      this.loadingData = true
      // Si es operador pasamos el parent
      const parentUserId = this.isOperatorUser
        ? this.$store.state.user.parentRef.id
        : this.$store.state.user.id
      const response = await validateCompanyByCif(
        parentUserId,
        this.notification.nif_titular
      )
      this.shareEmail =
        response && response.email !== undefined ? response.email : ''
      this.loadingData = false
      if (this.shareEmail !== '') {
        this.addEmail()
      } else {
        const message = this.$t('companyEmailEmpty')
        this.setSnackbar({ position: 'top', type: 'warning', message })
      }
    },
    closeGrid() {
      this.operatorsListFlag = false
    },
    async refreshIfNeeded() {
      if (this.isSharedAccess) return
      if (this.notification.estado === 'Aceptado') {
        try {
          this.loadingData = true
          if (this.notification?.document) {
            await synchronizeNotification(this.notification)
          } else {
            await acceptNotification(this.notification, null, true)
          }
        } finally {
          this.loadingData = false
        }
      }
    },
    async showEditNifDialog() {
      if (!this.editNifDialog) {
        this.cifsList = await listCifs()
      }
      this.editNifDialog = !this.editNifDialog
    },
    closeCifsGrid() {
      this.editNifDialog = false
    },
    async assignNifTitular(selectedCif) {
      this.editNifDialog = false
      try {
        this.loadingData = true
        if (
          (this.isEmptyNifTitular(this.notification) ||
            this.isIgnoredNifTitular(this.notification)) &&
          selectedCif
        ) {
          await updateNifTitular(this.notification.id, selectedCif)

          const message = this.$t('notificationNifTitularUpdatedSuccessfully')
          this.setSnackbar({ position: 'top', type: 'success', message })
        }
        this.loadingData = false
      } catch (err) {
        this.loadingData = false
        const message = getErrorText(err.toString())
        this.setSnackbar({
          timeout: '20000',
          position: 'top',
          type: 'warning',
          message,
        })
      }
    },
    isEmptyNifTitular(item) {
      return !(item.nif_titular && item.nif_titular.trim().length > 0)
    },
    isIgnoredNifTitular(item) {
      return (
        item.nif_titular &&
        item.nif_titular === this.ignoreWordAlwaysInSpanish()
      )
    },
    ignoreWordAlwaysInSpanish() {
      return this.$i18n.t('editNifDialog.ignoreWord', 'es') || 'IGNORAR'
    },
    isTitularOriginalModificado(item) {
      // Si el atributo existe y vale '1', entonces está modificado
      return item?.titular_original_modificado === '1'
    },
    async selectManager(managerId) {
      if (
        this.notification.managerRef &&
        this.notification.managerRef.id === managerId
      ) {
        return
      }
      this.selectedOperator = managerId
      this.selectedManagerType = 'user'
      this.menu = false
      await this.assignManager()
    },
    async selectGroup(groupId) {
      if (
        this.notification.managerRef &&
        this.notification.managerRef.id === groupId
      ) {
        return
      }
      this.selectedOperator = groupId
      this.selectedManagerType = 'group'
      this.menu = false
      await this.assignManager()
    },
    clearSelection() {
      this.selectedOperator = null
      this.selectedManagerType = null
    },
    fullName(obj, nameKey = 'name', surnameKey = 'surname') {
      if (!obj) return ''
      if (obj.fullName) return obj.fullName

      return [obj[nameKey], obj[surnameKey]]
        .filter((value) => typeof value === 'string' && value.trim() !== '')
        .join(' ')
    },
    isGroup(ref) {
      return isGroupRef(ref)
    },
    async canOperatorAccessToNotification(operator, notification) {
      // Segun las especificaciones de la tarea GOODOK-2039 si el responsable es un grupo y el operador
      // pertenece a ese grupo debe tomar en cuenta solo las empresas, y no aplicar tambien los filtros.
      const canBeManager = this.isGroup(notification.managerRef)
        ? canOperatorBeManager(withHeavyCache(operator), notification)
        : await canOperatorBeManagerWithFilters(
            withHeavyCache(operator),
            notification
          )

      return canBeManager && !operator.disabled
    },
    async loadGroupData(
      item,
      { forceReset = false, showLoading = false } = {}
    ) {
      if (!item.managerRef) {
        item.overlapIconColor = undefined
        return
      }

      // Bloqueo por item, evitar concurrencias
      if (item._loadingGroupData) return

      if (this.isGroup(item.managerRef)) {
        if (!item._groupState) {
          this.$set(item, '_groupState', {
            loading: false,
            operatorsLoaded: false,
            tooltipReady: false,
            accessReady: false,
          })
        }

        this.$set(item, '_loadingGroupData', true)
        item._groupState.loading = true
        item._groupState.tooltipReady = false
      }

      if (!item.overlapIconColor) {
        this.$set(item, 'overlapIconColor', 'loading')
      }

      try {
        // En el reproceso mostrar el icono loading
        if (!forceReset && showLoading) {
          ////this.$set(item, 'isReprocessing', true)
        }

        if (!this.isGroup(item.managerRef)) {
          // Añadir nueva propiedad reactiva solo para los usuarios, no grupos
          this.$set(item, 'canBeManager', null)

          // La notificacion tiene un responsable operador, no un grupo.
          // Puede haber algun caso en el que el operador este disabled (ya contemplado), pero tambien puede
          // ocurrir que al operador asignado le quiten la empresa y deje de ver la notificacion, en cuyo caso
          // hay que mostrar, a los usuarios admin, un triangulo rojo en el avatar del responsable.
          const operator =
            this.operatorsMap[item.managerRef.id] ??
            (await GetDocumentFromReference(item.managerRef))

          item.canBeManager = canOperatorBeManager(
            withHeavyCache(operator),
            item
          )
          this.updateOverlapIconColor(item) // Estado del avatar del operador
          return
        }

        // Es un Grupo
        // Si ya esta cargado volver a calcular los permisos igualmente, no guardar nada en cache
        // Estado inicial, aun no cargado (reactivo)
        if (forceReset) {
          item._groupState.operatorsLoaded = false
        }

        try {
          // Calcular el acceso a la notificacion
          await this.loadGroupOperatorsAccess(item)

          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false

          if (!this.getGroupOperators(item).length) {
            this.$set(item, 'groupAccess', {
              status: 'ready',
              map: {},
              summary: {
                hasAnyAccess: false,
                hasPending: false,
                rejectedAll: true,
              },
            })
            item.overlapIconColor = 'error'
            return
          }

          this.updateOverlapIconColor(item) // Estado del avatar del grupo
        } catch (e) {
          console.error(
            'Item id: ' +
              item.id +
              ' , Error cargando accesos de los operadores del grupo: ',
            this.groupsOperatorsMap[item.managerRef.id]?.fullName,
            e
          )
          item._groupState.operatorsLoaded = true
          item._groupState.tooltipReady = true
          item._groupState.loading = false
          item.overlapIconColor = 'error'
        }
      } finally {
        item._loadingGroupData = false
      }
    },
    async loadGroupOperatorsAccess(item) {
      if (!item.managerRef) return
      if (!this.isGroup(item.managerRef)) return

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      // grupos todavia no cargados en el mapa
      if (!entry) {
        return
      }
      const operatorIds = entry?.operatorIds ?? []
      const operators = operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)

      // limpiar e iniciar loading
      if (!item.groupAccess) {
        this.$set(item, 'groupAccess', {
          status: 'loading',
          map: {},
          summary: {},
        })
      }

      /* INFORMACION
       * Nuevo objeto ligero en cada notificacion, se define como sigue:
       * groupAccess = {
       *    status: puede ser 'loading' | 'ready' | 'error',
       *    map: [operatorId]
       *      { canAccess: boolean,
       *        hasError: boolean,
       *        response: {
       *          responded: boolean,
       *          accepted: boolean | null,
       *          lastResponseAt: timestamp | null,
       *          color,
       *          text,
       *        }
       *    },
       *    summary: {
       *      eligibleCount,
       *      hasAnyAccess,
       *      hasPending,
       *      rejectedAll,
       *      acceptedOperatorDeletedFromGroup,
       *      acceptedOperatorDeletedFromGroupFullname,
       *      lastAcceptedStillValid
       *      hasAccepted
       *    }
       * }
       *
       */

      try {
        const accessMap = {}
        // 1. acceso por operador
        // Procesado secuencial (no Promise.all)
        const responses = item?.responseOperators || []
        const responsesByOperator = {}

        for (const r of responses) {
          const prev = responsesByOperator[r.userRef.id]

          if (!prev || r.createdAt > prev.createdAt) {
            responsesByOperator[r.userRef.id] = {
              response: r.response,
              createdAt: r.createdAt,
            }
          }
        }

        for (const operator of operators) {
          const canAccess = await this.canOperatorAccessToNotification(
            operator,
            item
          )

          const responseInfo = responsesByOperator[operator.id] || null

          let color = ''
          if (operator.disabled) {
            color = ''
          } else if (responseInfo) {
            color = responseInfo.response === false ? 'error' : 'success'
          }

          let text = ''
          if (responseInfo) {
            if (responseInfo.response === false) {
              text = this.$t('operatorResponsabilityRejected')
            } else if (responseInfo.response === true) {
              text = this.$t('operatorResponsabilityAccepted')
            }

            if (responseInfo.createdAt) {
              // esta almacenada en milisegundos
              text += ' (' + this.formatDate(responseInfo.createdAt) + ')'
            }
          }

          accessMap[operator.id] = {
            canAccess,
            hasError: operator.disabled || canAccess !== true,
            response: {
              responded: !!responseInfo,
              accepted: responseInfo ? responseInfo.response : null,
              lastResponseAt: responseInfo ? responseInfo.createdAt : null,
              color,
              text,
            },
          }
        }

        // 2. elegibles, son lo que pueden acceder
        const eligibleOperators = operators.filter(
          (op) => !op.disabled && accessMap[op.id].canAccess === true
        )

        const eligibleCount = eligibleOperators.length

        // 3. pendientes
        const respondedIds = responses.map((r) => r.userRef.id)
        const hasPending = eligibleOperators.some(
          (op) => !respondedIds.includes(op.id)
        )

        // 4. rechazados globales
        const rejectedAll =
          eligibleOperators.length > 0 &&
          eligibleOperators.every((op) =>
            responses.some(
              (r) => r.userRef.id === op.id && r.response === false
            )
          )

        // 5. ultimo aceptado
        const acceptedOperators = responses
          .filter((r) => r.response === true)
          .sort((a, b) => b.createdAt - a.createdAt)

        let acceptedOperatorDeletedFromGroup = false
        let acceptedOperatorDeletedFromGroupFullname = ''
        let lastAcceptedStillValid = false

        if (acceptedOperators.length > 0) {
          const lastAccepted = acceptedOperators[0]

          const stillInGroup = operators.some(
            (op) => op.id === lastAccepted.userRef.id
          )

          acceptedOperatorDeletedFromGroup = !stillInGroup

          // Guardar el nombre del operador que aceptó y que ya no se encuentra en el grupo, para mostrarlo en el tooltip
          if (!stillInGroup) {
            const oper = this.operators.find(
              (op) => op.id === lastAccepted.userRef.id
            )

            if (oper) {
              acceptedOperatorDeletedFromGroupFullname = oper.fullName
            }
          }

          const accessOk = stillInGroup
            ? accessMap[lastAccepted.userRef.id].canAccess
            : false

          lastAcceptedStillValid = stillInGroup && accessOk
        }

        // hay alguien que tenga acceso ?
        const hasAnyAccess = eligibleOperators.length > 0

        // 6. commit final (una sola mutación reactiva)
        this.$set(item, 'groupAccess', {
          status: 'ready',
          map: accessMap,
          summary: {
            eligibleCount,
            hasAnyAccess,
            hasPending,
            rejectedAll,
            acceptedOperatorDeletedFromGroup,
            acceptedOperatorDeletedFromGroupFullname,
            lastAcceptedStillValid,
            hasAccepted: acceptedOperators.length > 0,
          },
        })
      } catch (e) {
        console.error('Error comprobando accesos del grupo', e)

        this.$set(item, 'groupAccess', {
          status: 'error',
          map: null,
          summary: null,
        })
      }
    },
    operatorAccessText(operator, item) {
      const groupAccess = item.groupAccess

      // estado del grupo
      if (!groupAccess || groupAccess.status === 'loading') {
        return this.$t('processing')
      }

      if (groupAccess.status === 'error') {
        return this.$t('operatorAccessNotificationKO')
      }

      if (operator.disabled) return this.$t('operatorDisabled')

      const canAccess = groupAccess.map?.[operator.id]?.canAccess
      return canAccess
        ? '' //this.$t('operatorAccessNotificationOK') // por defecto, si tiene acceso no pinta ningun texto
        : this.$t('operatorAccessNotificationKO')
    },
    onActivatorMouseEnter(e, item, on) {
      on.mouseenter(e) // asegura que Vuetify abra el tooltip
    },
    calculateOverlapIconColor(item) {
      if (!item.manager) return undefined

      // Si no es grupo, comportamiento normal de usuario
      if (!this.isGroup(item.managerRef)) {
        return item.manager?.disabled || item.canBeManager === false
          ? 'error'
          : !item.managerAccepted
          ? 'warning'
          : undefined
      }

      // Es un grupo, pero esta eliminado
      if (item.manager.deleted) return 'error'

      const groupAccess = item.groupAccess

      // Mientras se carga cualquier cosa del grupo: muestra el spinner
      if (!groupAccess || groupAccess.status !== 'ready') {
        return 'loading'
      }

      const operators = this.getGroupOperators(item)

      if (!operators.length) {
        return 'error'
      }

      const s = groupAccess.summary
      if (!s) return 'loading'

      // Nadie puede acceder
      if (!s.hasAnyAccess) return 'error'

      // Aceptó alguien y sigue siendo valido: ok, sin icono
      if (s.hasAccepted && s.lastAcceptedStillValid) {
        return undefined
      }

      // Aceptó alguien pero ya no es valido
      if (s.hasAccepted && !s.lastAcceptedStillValid) {
        return 'error'
      }

      // Hay pendientes
      if (s.hasPending) {
        return 'warning'
      }

      // Caso final: nadie pendiente y nadie aceptado valido
      return 'error'
    },
    hasOperatorResponded(item, operator) {
      if (!operator) return false
      return item?.responseOperators?.some((r) => r.userRef.id === operator.id)
    },
    checkIfUserBelongsToGroup(userRef) {
      if (this.isGroup(this.notification.managerRef)) {
        const entry = this.groupsOperatorsMap[this.notification.managerRef.id]
        if (!entry) {
          return false
        }
        const operatorIds = entry?.operatorIds ?? []
        return operatorIds.includes(userRef.id)
      }

      return false
    },
    getLatestOperatorResponse(notification, operator) {
      return this.getOperatorResponses(notification, operator)?.latest ?? null
    },
    getOperatorResponses(notification, operator) {
      // ahora un operador puede tener mas de una respuesta (p.e. rechazar y despues aceptar)
      // devuelve el objeto con la info necesaria: quién, qué y cuándo
      if (!notification.responseOperators?.length) {
        return { latest: null, history: [] }
      }

      const responses = notification.responseOperators
        .filter((r) => r.userRef.id === operator.id)
        .slice() // copia defensiva, evita mutar el array original
        .sort((a, b) => b.createdAt - a.createdAt) // mas reciente arriba

      return {
        latest: responses[0] ?? null,
        history: responses.slice(1),
      }
    },
    formatDate(ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const pad = (n) => String(n).padStart(2, '0')

      return (
        `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        //`${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
        `${pad(d.getHours())}:${pad(d.getMinutes())}`
      )
    },
    hasGroupChanged(prev, curr) {
      if (prev.fullName !== curr.fullName) return true
      if (prev.deleted !== curr.deleted) return true

      if (
        JSON.stringify(this.normalizeArray(prev.cifsRef)) !==
        JSON.stringify(this.normalizeArray(curr.cifsRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.filtersRef)) !==
        JSON.stringify(this.normalizeArray(curr.filtersRef))
      )
        return true

      if (
        JSON.stringify(this.normalizeArray(prev.usersRef)) !==
        JSON.stringify(this.normalizeArray(curr.usersRef))
      )
        return true

      return false
    },
    normalizeArray(arr) {
      // Normaliza los arrays de referencias:
      // - Extrae id si es una referencia
      // - Ordena para evitar cambios de orden irrelevantes
      if (!Array.isArray(arr)) return []
      return arr.map((item) => item?.id ?? item).sort()
    },
    updateOverlapIconColor(item) {
      const color = this.calculateOverlapIconColor(item)
      if (item.overlapIconColor !== color) {
        this.$set(item, 'overlapIconColor', color)
      }
    },
    getGroupOperators(item) {
      if (!item?.managerRef || !this.isGroup(item.managerRef)) return []

      const entry = this.groupsOperatorsMap[item.managerRef.id]
      if (!entry?.operatorIds?.length) return []

      return entry.operatorIds
        .map((id) => this.operatorsMap[id])
        .filter(Boolean)
    },
    getGroupOperatorsPreview(item) {
      const operators = this.getGroupOperators(item)
      // primero ordenar y luego hacer el slice
      return this.sortOperatorsByFullName(operators).slice(
        0,
        this.maxOperatorsPreview
      )
    },
    sortOperatorsByFullName(operators = []) {
      // ordenar por nombre, sin mutar el array original.
      return [...operators].sort((a, b) =>
        a.fullName.localeCompare(b.fullName, 'es', { sensitivity: 'base' })
      )
    },
    filteredByManagerSearch(list) {
      const q = this.managerSearch?.trim().toLowerCase()
      if (!q) return list || []

      return (list || []).filter((item) =>
        item.fullName?.toLowerCase().includes(q)
      )
    },
    async acceptResponsibilityQuestion() {
      this.responsabilityQuestionResponse = 'accept'
      this.askAgainFlag = false
      await saveOperatorResponse(this.notification.id, true)
    },
    async rejectResponsibilityQuestion() {
      this.responsabilityQuestionResponse = 'reject'
      this.askAgainFlag = false
      await saveOperatorResponse(this.notification.id, false)
    },
    askLaterResponsibilityQuestion() {
      this.responsabilityQuestionResponse = 'ignore'
      this.askAgainFlag = false
    },
    openGroupOperators() {
      this.menuAllGroupOperators = true
    },
    goBackToList() {
      this.$router.push({
        name: 'NotificationsView',
      })
    },
    goToPrevious() {
      if (!this.hasPrevious) return

      const newIndex = this.nav.index - 1
      const id = this.nav.ids[newIndex]

      this.$store.commit('setNotificationNavIndex', newIndex)
      this.updateCurrentPageFromIndex(newIndex)

      // El uso de router.replace no contamina el historial
      this.$router.replace({
        name: 'NotificationDetailView',
        params: { id },
      })
    },
    goToNext() {
      if (!this.hasNext) return

      const newIndex = this.nav.index + 1
      const id = this.nav.ids[newIndex]

      this.$store.commit('setNotificationNavIndex', newIndex)
      this.updateCurrentPageFromIndex(newIndex)

      this.$router.replace({
        name: 'NotificationDetailView',
        params: { id },
      })
    },
    updateCurrentPageFromIndex(index) {
      // Comprueba si al navegar se esta cambiando de pagina y entonces almacena la nueva pagina
      if (this.userHasSorted) return

      const options = this.$store.state.notificationsListOptions
      const page = Math.floor(index / options.itemsPerPage) + 1

      if (page !== options.page) {
        this.$store.commit('setNotificationsListOptions', {
          ...options,
          page,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.without-nif {
  background-color: #d70a0a;
  color: white;
  font-weight: bold;
  padding: 6px 6px;
  border-radius: 4px;
  white-space: nowrap;
  max-width: 150px;
  min-width: 150px;
  height: 36px;
  display: flex;
  align-items: center;
}

.wrap-text {
  white-space: normal !important;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.nif-wrapper {
  display: inline-flex;
  align-items: center;
}

/* tooltip de grupo: color gris un poco mas oscuro y eliminar la transparencia */
.tooltip-no-transparency {
  background-color: rgba(97, 97, 97, 1) !important; /* opaco */
  color: #ffffff; /* texto base legible */
}

.tooltip-loading {
  min-width: 260px;
  min-height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.group-operators-info {
  display: flex;
  align-items: center; /* Alinea chip y texto verticalmente */
  margin-top: 12px; /* Igual que mt-3 */
  padding-left: 8px; /* Ajusta al borde izquierdo del tooltip */
}

.operator-count-chip {
  margin-right: 8px; /* espacio entre chip y texto */
}

.operator-count-text {
  font-size: 0.875rem; /* Igual que body-2, ajustable */
  color: #ffffff; /* texto base legible */
}

/* menu de operadores y grupos */
.responsible-menu {
  /*max-width: 600px;*/
  overflow-y: auto;
}

/* bloquea el resto del componente ante respuesta obligatoria a la pregunta sobre responsabilidad */
.position-relative {
  position: relative;
}

.absolute-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.6); /* semi-transparente */
  z-index: 10;
  pointer-events: all; /* bloquea clicks en todo lo de debajo */
}

/* vcard de pregunta sobre responsabilidad
* animacion del vcard de pregunta sobre responsabilidad:
* El v-card 'respira', expandiendose ligeramente arriba y abajo,
* mostrando un color azul claro/pastel alrededor, que deriva del color primary.
*/
.responsibility-card {
  position: relative;
  z-index: 20;
  animation: responsibility-pulse 700ms ease-out 1;
}

@keyframes responsibility-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.35);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(25, 118, 210, 0);
  }
  100% {
    box-shadow: none;
  }
}

/* muestra la 'respiracion' solo si es persistente, para llamar la atencion del usuario */
.is-persistent {
  animation: responsibility-pulse 700ms ease-out 1,
    responsibility-breathe 3.5s ease-in-out infinite;
}

@keyframes responsibility-breathe {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(25, 118, 210, 0.15);
  }
  50% {
    box-shadow: 0 0 0 6px rgba(25, 118, 210, 0.25);
  }
}

/* reserva la altura del boton que muestra todos los operadores del grupo*/
.group-operators-btn-wrapper {
  min-height: 28px; /* o la altura real del botón */
  display: flex;
  align-items: center; /* centra el botón verticalmente */
}

.group-deleted {
  background-color: #d70a0a;
  color: white;
  /*font-weight: bold;*/
  padding: 2px 2px;
  border-radius: 2px;
}

.tooltip-text {
  margin: 0;
}
</style>
